import EnvironmentManager from 'Utils/environmentManager';
export * from 'Store/constants/betSlip';
export * from 'Store/constants/chanceGames';
export * from 'Store/constants/lottery';
export * from 'Store/constants/raffle';
export * from 'Store/constants/socialCoupon';
export * from 'Store/constants/tribun';
export * from 'Store/constants/utils';
export * from 'Store/constants/liveScore';
export * from 'Store/constants/authorsMetaTag';
export * from 'Store/constants/externalGameTypes';

export const GET_MESSAGE_REQUEST = 'GET_MESSAGE_REQUEST';
export const GET_MESSAGE_SUCCESS = 'GET_MESSAGE_SUCCESS';
export const GET_MESSAGE_FAILURE = 'GET_MESSAGE_FAILURE';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const RESET_LOGIN_FAILURE = 'RESET_LOGIN_FAILURE';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';
export const PREDEACTIVATED_STATUS_LOGIN_SUCCESS = 'PREDEACTIVATED_STATUS_LOGIN_SUCCESS';
export const SET_PENDING_MEMBERSHIP = 'SET_PENDING_MEMBERSHIP';
export const CLEAR_PENDING_MEMBERSHIP = 'CLEAR_PENDING_MEMBERSHIP';

export const GET_MAIN_SLIDER_V2_REQUEST = 'GET_MAIN_SLIDER_V2_REQUEST';
export const GET_MAIN_SLIDER_V2_SUCCESS = 'GET_MAIN_SLIDER_V2_SUCCESS';
export const GET_MAIN_SLIDER_V2_FAILURE = 'GET_MAIN_SLIDER_V2_FAILURE';
export const MAIN_SLIDER_ODDS_WS_UPDATE = 'MAIN_SLIDER_ODDS_WS_UPDATE';
export const MAIN_SLIDER_ODDS_WS_V2_UPDATE = 'MAIN_SLIDER_ODDS_WS_V2_UPDATE';
export const MAIN_SLIDER_EVENT_REMOVED_WS_V2 = 'MAIN_SLIDER_EVENT_REMOVED_WS_V2';
export const MAIN_SLIDER_EVENT_ADDED_WS_V2 = 'MAIN_SLIDER_EVENT_ADDED_WS_V2';

export const GET_HOME_SUB_HEADER_REQUEST = 'GET_HOME_SUB_HEADER_REQUEST';
export const GET_HOME_SUB_HEADER_SUCCESS = 'GET_HOME_SUB_HEADER_SUCCESS';
export const GET_HOME_SUB_HEADER_FAILURE = 'GET_HOME_SUB_HEADER_FAILURE';

export const GET_HOME_CAMPAIGN_REQUEST = 'GET_HOME_CAMPAIGN_REQUEST';
export const GET_HOME_CAMPAIGN_SUCCESS = 'GET_HOME_CAMPAIGN_SUCCESS';
export const GET_HOME_CAMPAIGN_FAILURE = 'GET_HOME_CAMPAIGN_FAILURE';

export const GET_VAIX_SEARCH_PRE_SEARCH_REQUEST = 'GET_VAIX_SEARCH_PRE_SEARCH_REQUEST';
export const GET_VAIX_SEARCH_PRE_SEARCH_SUCCESS = 'GET_VAIX_SEARCH_PRE_SEARCH_SUCCESS';
export const GET_VAIX_SEARCH_PRE_SEARCH_FAILURE = 'GET_VAIX_SEARCH_PRE_SEARCH_FAILURE';

export const GET_VAIX_SEARCH_AFTER_SEARCH_REQUEST = 'GET_VAIX_SEARCH_AFTER_SEARCH_REQUEST';
export const GET_VAIX_SEARCH_AFTER_SEARCH_SUCCESS = 'GET_VAIX_SEARCH_AFTER_SEARCH_SUCCESS';
export const GET_VAIX_SEARCH_AFTER_SEARCH_FAILURE = 'GET_VAIX_SEARCH_AFTER_SEARCH_FAILURE';

export const GET_VAIX_SEARCH_AFTER_SEARCH_GAMELIST_EVENT_REQUEST = 'GET_VAIX_SEARCH_AFTER_SEARCH_GAMELIST_EVENT_REQUEST';
export const GET_VAIX_SEARCH_AFTER_SEARCH_GAMELIST_EVENT_SUCCESS = 'GET_VAIX_SEARCH_AFTER_SEARCH_GAMELIST_EVENT_SUCCESS';
export const GET_VAIX_SEARCH_AFTER_SEARCH_GAMELIST_EVENT_FAILURE = 'GET_VAIX_SEARCH_AFTER_SEARCH_GAMELIST_EVENT_FAILURE';

export const GET_LIVE_STREAM_TABS_REQUEST = 'GET_LIVE_STREAM_TABS_REQUEST';
export const GET_LIVE_STREAM_TABS_SUCCESS = 'GET_LIVE_STREAM_TABS_SUCCESS';
export const GET_LIVE_STREAM_TABS_FAILURE = 'GET_LIVE_STREAM_TABS_FAILURE';

export const GET_LOTTERY_WIDGET_REQUEST = 'GET_LOTTERY_WIDGET_REQUEST';
export const GET_LOTTERY_WIDGET_SUCCESS = 'GET_LOTTERY_WIDGET_SUCCESS';
export const GET_LOTTERY_WIDGET_FAILURE = 'GET_LOTTERY_WIDGET_FAILURE';

export const GET_LIVE_STREAM_DATA_REQUEST = 'GET_LIVE_STREAM_DATA_REQUEST';
export const GET_LIVE_STREAM_DATA_SUCCESS = 'GET_LIVE_STREAM_DATA_SUCCESS';
export const GET_LIVE_STREAM_DATA_FAILURE = 'GET_LIVE_STREAM_DATA_FAILURE';

export const GET_LIVE_STREAM_COUPONS_DATA_REQUEST = 'GET_LIVE_STREAM_COUPONS_DATA_REQUEST';
export const GET_LIVE_STREAM_COUPONS_DATA_SUCCESS = 'GET_LIVE_STREAM_COUPONS_DATA_SUCCESS';
export const GET_LIVE_STREAM_COUPONS_DATA_FAILURE = 'GET_LIVE_STREAM_COUPONS_DATA_FAILURE';

export const AUTHENTICATE_LIVE_STREAM_REQUEST = 'AUTHENTICATE_LIVE_STREAM_REQUEST';
export const AUTHENTICATE_LIVE_STREAM_SUCCESS = 'AUTHENTICATE_LIVE_STREAM_SUCCESS';
export const AUTHENTICATE_LIVE_STREAM_FAILURE = 'AUTHENTICATE_LIVE_STREAM_FAILURE';

export const AUTHENTICATE_PERFORM_LIVE_STREAM = 'AUTHENTICATE_PERFORM_LIVE_STREAM';

export const RESET_LIVE_STREAM_AUTHENTICATE = 'RESET_LIVE_STREAM_AUTHENTICATE';

export const GET_LONG_TERM_DATA_REQUEST = 'GET_LONG_TERM_DATA_REQUEST';
export const GET_LONG_TERM_DATA_SUCCESS = 'GET_LONG_TERM_DATA_SUCCESS';
export const GET_LONG_TERM_DATA_FAILURE = 'GET_LONG_TERM_DATA_FAILURE';

export const GET_MATCH_CARD_ODDS_REQUEST = 'GET_MATCH_CARD_ODDS_REQUEST';
export const GET_MATCH_CARD_ODDS_SUCCESS = 'GET_MATCH_CARD_ODDS_SUCCESS';
export const GET_MATCH_CARD_ODDS_FAILURE = 'GET_MATCH_CARD_ODDS_FAILURE';

export const MATCH_CARD_SCORE_UPDATE = 'MATCH_CARD_SCORE_UPDATE';

export const GET_AUTHOR_COMMENTS_REQUEST = 'GET_AUTHOR_COMMENTS_REQUEST';
export const GET_AUTHOR_COMMENTS_SUCCESS = 'GET_AUTHOR_COMMENTS_SUCCESS';
export const GET_AUTHOR_COMMENTS_FAILURE = 'GET_AUTHOR_COMMENTS_FAILURE';

export const GET_AUTHOR_BY_ID_REQUEST = 'GET_AUTHOR_BY_ID_REQUEST';
export const GET_AUTHOR_BY_ID_SUCCESS = 'GET_AUTHOR_BY_ID_SUCCESS';
export const GET_AUTHOR_BY_ID_FAILURE = 'GET_AUTHOR_BY_ID_FAILURE';

export const GET_INJURED_BANNED_DATA_REQUEST = 'GET_INJURED_BANNED_DATA_REQUEST';
export const GET_INJURED_BANNED_DATA_SUCCESS = 'GET_INJURED_BANNED_DATA_SUCCESS';
export const GET_INJURED_BANNED_DATA_FAILURE = 'GET_INJURED_BANNED_DATA_FAILURE';

export const GET_MATCH_CARD_DETAILS_REQUEST = 'GET_MATCH_CARD_DETAILS_REQUEST';
export const GET_MATCH_CARD_DETAILS_SUCCESS = 'GET_MATCH_CARD_DETAILS_SUCCESS';
export const GET_MATCH_CARD_DETAILS_FAILURE = 'GET_MATCH_CARD_DETAILS_FAILURE';

export const GET_SMART_ANALYSIS_REQUEST = 'GET_SMART_ANALYSIS_REQUEST';
export const GET_SMART_ANALYSIS_SUCCESS = 'GET_SMART_ANALYSIS_SUCCESS';
export const GET_SMART_ANALYSIS_FAILURE = 'GET_SMART_ANALYSIS_FAILURE';

export const GET_MATCH_CARD_HEADER_REQUEST = 'GET_MATCH_CARD_HEADER_REQUEST';
export const GET_MATCH_CARD_HEADER_SUCCESS = 'GET_MATCH_CARD_HEADER_SUCCESS';
export const GET_MATCH_CARD_HEADER_FAILURE = 'GET_MATCH_CARD_HEADER_FAILURE';

export const GET_MATCH_CARD_HEADER_STATISTICS_REQUEST = 'GET_MATCH_CARD_HEADER_STATISTICS_REQUEST';
export const GET_MATCH_CARD_HEADER_STATISTICS_SUCCESS = 'GET_MATCH_CARD_HEADER_STATISTICS_SUCCESS';
export const GET_MATCH_CARD_HEADER_STATISTICS_FAILURE = 'GET_MATCH_CARD_HEADER_STATISTICS_FAILURE';

export const GET_MATCH_CARD_STANDINGS_REQUEST = 'GET_MATCH_CARD_STANDINGS_REQUEST';
export const GET_MATCH_CARD_STANDINGS_SUCCESS = 'GET_MATCH_CARD_STANDINGS_SUCCESS';
export const GET_MATCH_CARD_STANDINGS_FAILURE = 'GET_MATCH_CARD_STANDINGS_FAILURE';

export const RESET_MATCH_CARD = 'RESET_MATCH_CARD';

export const GET_EVENTS_AVAILABLE_TABS_REQUEST = 'GET_EVENTS_AVAILABLE_TABS_REQUEST';
export const GET_EVENTS_AVAILABLE_TABS_SUCCESS = 'GET_EVENTS_AVAILABLE_TABS_SUCCESS';
export const GET_EVENTS_AVAILABLE_TABS_FAILURE = 'GET_EVENTS_AVAILABLE_TABS_FAILURE';


export const RESET_TEAM_CARD_DATA = 'RESET_TEAM_CARD_DATA';

export const GET_TEAM_CARD_DATA_REQUEST = 'GET_TEAM_CARD_DATA_REQUEST';
export const GET_TEAM_CARD_DATA_SUCCESS = 'GET_TEAM_CARD_DATA_SUCCESS';
export const GET_TEAM_CARD_DATA_FAILURE = 'GET_TEAM_CARD_DATA_FAILURE';

export const GET_STATISTICS_DATA_REQUEST = 'GET_STATISTICS_DATA_REQUEST';
export const GET_STATISTICS_DATA_SUCCESS = 'GET_STATISTICS_DATA_SUCCESS';
export const GET_STATISTICS_DATA_FAILURE = 'GET_STATISTICS_DATA_FAILURE';

export const GET_LEAGUE_CARD_DATA_REQUEST = 'GET_LEAGUE_CARD_DATA_REQUEST';
export const GET_LEAGUE_CARD_DATA_SUCCESS = 'GET_LEAGUE_CARD_DATA_SUCCESS';
export const GET_LEAGUE_CARD_DATA_FAILURE = 'GET_LEAGUE_CARD_DATA_FAILURE';

export const GET_EVENTS_ROWS_REQUEST = 'GET_EVENTS_ROWS_REQUEST';
export const GET_EVENTS_ROWS_SUCCESS = 'GET_EVENTS_ROWS_SUCCESS';
export const GET_EVENTS_ROWS_FAILURE = 'GET_EVENTS_ROWS_FAILURE';

export const GET_EVENTS_AVAILABLE_FILTERS = 'GET_EVENTS_AVAILABLE_FILTERS';

export const GET_LIVE_STATISTICS_REQUEST = 'GET_LIVE_STATISTICS_REQUEST';
export const GET_LIVE_STATISTICS_SUCCESS = 'GET_LIVE_STATISTICS_SUCCESS';
export const GET_LIVE_STATISTICS_FAILURE = 'GET_LIVE_STATISTICS_FAILURE';

export const GET_TEAM_CARD_DATA_BY_SEASON_REQUEST = 'GET_TEAM_CARD_DATA_BY_SEASON_REQUEST';
export const GET_TEAM_CARD_DATA_BY_SEASON_SUCCESS = 'GET_TEAM_CARD_DATA_BY_SEASON_SUCCESS';
export const GET_TEAM_CARD_DATA_BY_SEASON_FAILURE = 'GET_TEAM_CARD_DATA_BY_SEASON_FAILURE';

export const GET_FIXTURES_REQUEST = 'GET_FIXTURES_REQUEST';
export const GET_FIXTURES_SUCCESS = 'GET_FIXTURES_SUCCESS';
export const GET_FIXTURES_FAILURE = 'GET_FIXTURES_FAILURE';

export const GET_HELP_MENU_ITEMS_REQUEST = 'GET_HELP_MENU_ITEMS_REQUEST';
export const GET_HELP_MENU_ITEMS_SUCCESS = 'GET_HELP_MENU_ITEMS_SUCCESS';
export const GET_HELP_MENU_ITEMS_FAILURE = 'GET_HELP_MENU_ITEMS_FAILURE';

export const GET_HELP_MENU_DETAILS_REQUEST = 'GET_HELP_MENU_DETAILS_REQUEST';
export const GET_HELP_MENU_DETAILS_SUCCESS = 'GET_HELP_MENU_DETAILS_SUCCESS';
export const GET_HELP_MENU_SUCCESS = 'GET_HELP_MENU_SUCCESS';
export const GET_HELP_MENU_DETAILS_FAILURE = 'GET_HELP_MENU_DETAILS_FAILURE';

export const GET_CMS_UPDATER_REQUEST = 'GET_CMS_UPDATER_REQUEST';
export const GET_CMS_UPDATER_SUCCESS = 'GET_CMS_UPDATER_SUCCESS';
export const GET_CMS_UPDATER_FAILURE = 'GET_CMS_UPDATER_FAILURE';

export const GET_DEPOSIT_MENU_REQUEST = 'GET_DEPOSIT_MENU_REQUEST';
export const GET_DEPOSIT_MENU_SUCCESS = 'GET_DEPOSIT_MENU_SUCCESS';
export const GET_DEPOSIT_MENU_FAILURE = 'GET_DEPOSIT_MENU_FAILURE';

export const GET_BANK_DEPOSITS_ACCOUNTS_REQUEST = 'GET_BANK_DEPOSITS_ACCOUNTS_REQUEST';
export const GET_BANK_DEPOSITS_ACCOUNTS_SUCCESS = 'GET_BANK_DEPOSITS_ACCOUNTS_SUCCESS';
export const GET_BANK_DEPOSITS_ACCOUNTS_FAILURE = 'GET_BANK_DEPOSITS_ACCOUNTS_FAILURE';

export const GET_BANK_DEPOSIT_FEES_REQUEST = 'GET_BANK_DEPOSIT_FEES_REQUEST';
export const GET_BANK_DEPOSIT_FEES_SUCCESS = 'GET_BANK_DEPOSIT_FEES_SUCCESS';
export const GET_BANK_DEPOSIT_FEES_FAILURE = 'GET_BANK_DEPOSIT_FEES_FAILURE';

export const GET_BANK_DEPOSIT_FEE_DETAILS_REQUEST = 'GET_BANK_DEPOSIT_FEE_DETAILS_REQUEST';
export const GET_BANK_DEPOSIT_FEE_DETAILS_SUCCESS = 'GET_BANK_DEPOSIT_FEE_DETAILS_SUCCESS';
export const GET_BANK_DEPOSIT_FEE_DETAILS_FAILURE = 'GET_BANK_DEPOSIT_FEE_DETAILS_FAILURE';
export const CLEAR_BANK_DEPOSIT_FEE_DETAILS = 'CLEAR_BANK_DEPOSIT_FEE_DETAILS';

export const GET_USER_CONTRACT_REQUEST = 'GET_USER_CONTRACT_REQUEST';
export const GET_USER_CONTRACT_SUCCESS = 'GET_USER_CONTRACT_SUCCESS';
export const GET_USER_CONTRACT_FAILURE = 'GET_USER_CONTRACT_FAILURE';

export const GET_KVKK_AGREEMENT_REQUEST = 'GET_KVKK_AGREEMENT_REQUEST';
export const GET_KVKK_AGREEMENT_SUCCESS = 'GET_KVKK_AGREEMENT_SUCCESS';
export const GET_KVKK_AGREEMENT_FAILURE = 'GET_KVKK_AGREEMENT_FAILURE';

export const ACCEPT_KVKK_AGREEMENT_REQUEST = 'ACCEPT_KVKK_AGREEMENT_REQUEST';
export const ACCEPT_KVKK_AGREEMENT_SUCCESS = 'ACCEPT_KVKK_AGREEMENT_SUCCESS';
export const ACCEPT_KVKK_AGREEMENT_FAILURE = 'ACCEPT_KVKK_AGREEMENT_FAILURE';

export const CAMPAIGN_JOIN_SUCCESS = 'CAMPAIGN_JOIN_SUCCESS';

export const SET_CAMPAIGN_KVKK_STATE = 'SET_CAMPAIGN_KVKK_STATE';

export const CHECK_CAMPAIGN_JOIN_REQUEST = 'CHECK_CAMPAIGN_JOIN_REQUEST';
export const CHECK_CAMPAIGN_JOIN_SUCCESS = 'CHECK_CAMPAIGN_JOIN_SUCCESS';
export const CHECK_CAMPAIGN_JOIN_FAILURE = 'CHECK_CAMPAIGN_JOIN_FAILURE';

export const GET_CAMPAIGN_RESULT_REQUEST = 'GET_CAMPAIGN_RESULT_REQUEST';
export const GET_CAMPAIGN_RESULT_SUCCESS = 'GET_CAMPAIGN_RESULT_SUCCESS';
export const GET_CAMPAIGN_RESULT_FAILURE = 'GET_CAMPAIGN_RESULT_FAILURE';

export const GET_USER_CAMPAIGN_RESULT_REQUEST = 'GET_USER_CAMPAIGN_RESULT_REQUEST';
export const GET_USER_CAMPAIGN_RESULT_SUCCESS = 'GET_USER_CAMPAIGN_RESULT_SUCCESS';
export const GET_USER_CAMPAIGN_RESULT_FAILURE = 'GET_USER_CAMPAIGN_RESULT_FAILURE';

export const GET_CAMPAIGN_PRIZE_REQUEST = 'GET_CAMPAIGN_PRIZE_REQUEST';
export const GET_CAMPAIGN_PRIZE_SUCCESS = 'GET_CAMPAIGN_PRIZE_SUCCESS';
export const GET_CAMPAIGN_PRIZE_FAILURE = 'GET_CAMPAIGN_PRIZE_FAILURE';

export const GET_USER_AGREEMENT_REQUEST = 'GET_USER_AGREEMENT_REQUEST';
export const GET_USER_AGREEMENT_SUCCESS = 'GET_USER_AGREEMENT_SUCCESS';
export const GET_USER_AGREEMENT_FAILURE = 'GET_USER_AGREEMENT_FAILURE';

export const USER_CONTRACT_ACCEPTED = 'USER_CONTRACT_ACCEPTED';
export const USER_AGREEMENT_DAILY_SHOW_COUNT_DEFAULTS = 1;

export const ACCEPT_SCORE_WARNING = 'ACCEPT_SCORE_WARNING';

export const POST_REGISTER_VALIDATE_REQUEST = 'POST_REGISTER_VALIDATE_REQUEST';
export const POST_REGISTER_VALIDATE_SUCCESS = 'POST_REGISTER_VALIDATE_SUCCESS';
export const POST_REGISTER_VALIDATE_FAILURE = 'POST_REGISTER_VALIDATE_FAILURE';

export const POST_OTP_REQUEST = 'POST_OTP_REQUEST';
export const POST_OTP_SUCCESS = 'POST_OTP_SUCCESS';
export const POST_OTP_FAILURE = 'POST_OTP_FAILURE';

export const POST_OTP_VERIFY_REQUEST = 'POST_OTP_VERIFY_REQUEST';
export const POST_OTP_VERIFY_SUCCESS = 'POST_OTP_VERIFY_SUCCESS';
export const POST_OTP_VERIFY_FAILURE = 'POST_OTP_VERIFY_FAILURE';

export const POST_REGISTER_REQUEST = 'POST_REGISTER_REQUEST';
export const POST_REGISTER_SUCCESS = 'POST_REGISTER_SUCCESS';
export const POST_REGISTER_FAILURE = 'POST_REGISTER_FAILURE';

export const GET_CAMPAIGN_DATA_REQUEST = 'GET_CAMPAIGN_DATA_REQUEST';
export const GET_CAMPAIGN_DATA_SUCCESS = 'GET_CAMPAIGN_DATA_SUCCESS';
export const GET_CAMPAIGN_DATA_FAILURE = 'GET_CAMPAIGN_DATA_FAILURE';

export const GET_CAMPAIGN_DETAIL_REQUEST = 'GET_CAMPAIGN_DETAIL_REQUEST';
export const GET_CAMPAIGN_DETAIL_SUCCESS = 'GET_CAMPAIGN_DETAIL_SUCCESS';
export const GET_CAMPAIGN_DETAIL_FAILURE = 'GET_CAMPAIGN_DETAIL_FAILURE';

// Modal Constans
export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

// Betslip constants
export const BETSLIP_SET_HAS_LIVE_EVENT = 'BETSLIP_SET_HAS_LIVE_EVENT';
export const BETSLIP_OPENED = 'BETSLIP_OPENED';
export const BETSLIP_CLOSED = 'BETSLIP_CLOSED';
export const BETSLIP_SETTINGS_OPENED = 'BETSLIP_SETTINGS_OPENED';
export const BETSLIP_SETTINGS_CLOSED = 'BETSLIP_SETTINGS_CLOSED';
export const BETSLIP_SETTINGS_UPDATED = 'BETSLIP_SETTINGS_UPDATED';

export const VALIDATE_MBS_STATE = 'VALIDATE_MBS_STATE';

export const PLAY_COUPON_REQUEST = 'PLAY_COUPON_REQUEST';
export const PLAY_COUPON_SUCCESS = 'PLAY_COUPON_SUCCESS';
export const PLAY_COUPON_RECOMMENDED_SUCCESS = 'PLAY_COUPON_RECOMMENDED_SUCCESS';
export const PLAY_COUPON_FAILURE = 'PLAY_COUPON_FAILURE';
export const PLAY_COUPON_UPDATE_PREDICTA = 'PLAY_COUPON_UPDATE_PREDICTA';
export const RESET_PLAY_COUPON = 'RESET_PLAY_COUPON';

export const SET_MULTIPLE_COUPON_DATA = 'SET_MULTIPLE_COUPON_DATA';
export const RESET_MULTIPLE_COUPON_DATA = 'RESET_MULTIPLE_COUPON_DATA';

export const VALIDATE_BETSLIP_REQUEST = 'VALIDATE_BETSLIP_REQUEST';
export const VALIDATE_BETSLIP_SUCCESS = 'VALIDATE_BETSLIP_SUCCESS';
export const VALIDATE_BETSLIP_FAILURE = 'VALIDATE_BETSLIP_FAILURE';

export const ADD_EVENT_TO_BETSLIP_SUCCESS = 'ADD_EVENT_TO_BETSLIP_SUCCESS';
export const ADD_EVENT_TO_BETSLIP_FAILURE = 'ADD_EVENT_TO_BETSLIP_FAILURE';
export const ADD_MULTIPLE_EVENTS_TO_BETSLIP = 'ADD_MULTIPLE_EVENTS_TO_BETSLIP';
export const ADD_MULTIPLE_EVENTS_TO_BETSLIP_SUCCESS = 'ADD_MULTIPLE_EVENTS_TO_BETSLIP_SUCCESS';
export const REMOVE_EVENT_FROM_BETSLIP = 'REMOVE_EVENT_FROM_BETSLIP';
export const SET_BETSLIP_MULTIPLIER = 'SET_BETSLIP_MULTIPLIER';
export const SET_BETSLIP_COUPON_COUNT = 'SET_BETSLIP_COUPON_COUNT';
export const SET_BETSLIP_SYSTEM = 'SET_BETSLIP_SYSTEM';
export const TOGGLE_BETSLIP_BANKER = 'TOGGLE_BETSLIP_BANKER';

export const PREDICTA_COMPUTE_REQUEST = 'PREDICTA_COMPUTE_REQUEST';
export const PREDICTA_COMPUTE_SUCCESS = 'PREDICTA_COMPUTE_SUCCESS';
export const PREDICTA_COMPUTE_FAILURE = 'PREDICTA_COMPUTE_FAILURE';

export const SET_PREDICTA_SUGGESTION_ACCEPTED = 'SET_PREDICTA_SUGGESTION_ACCEPTED';

export const FETCH_PREDICTA_BONUS_CAMPAIGN_REQUEST = 'FETCH_PREDICTA_BONUS_CAMPAIGN_REQUEST';
export const FETCH_PREDICTA_BONUS_CAMPAIGN_SUCCESS = 'FETCH_PREDICTA_BONUS_CAMPAIGN_SUCCESS';
export const FETCH_PREDICTA_BONUS_CAMPAIGN_FAILURE = 'FETCH_PREDICTA_BONUS_CAMPAIGN_FAILURE';

export const FETCH_PREDICTA_SUGGESTION_REQUEST = 'FETCH_PREDICTA_SUGGESTION_REQUEST';
export const FETCH_PREDICTA_SUGGESTION_SUCCESS = 'FETCH_PREDICTA_SUGGESTION_SUCCESS';
export const FETCH_PREDICTA_SUGGESTION_FAILURE = 'FETCH_PREDICTA_SUGGESTION_FAILURE';

export const SAVE_COUPON_REQUEST = 'SAVE_COUPON_REQUEST';
export const SAVE_COUPON_SUCCESS = 'SAVE_COUPON_SUCCESS';
export const SAVE_COUPON_FAILURE = 'SAVE_COUPON_FAILURE';

export const RESET_BETSLIP = 'RESET_BETSLIP';

// Local Storage constans
export const SET_BETSLIP_FROM_LOCAL_STORAGE = 'SET_BETSLIP_FROM_LOCAL_STORAGE';
export const SET_PREMATCH_FILTER_REQUEST_FROM_LOCAL_STORAGE = 'SET_PREMATCH_FILTER_REQUEST_FROM_LOCAL_STORAGE';

// Live score constants
export const SET_LIVE_SCORES_FILTERS_FROM_LOCAL_STORAGE = 'SET_LIVE_SCORES_FILTERS_FROM_LOCAL_STORAGE';
export const LIVE_SCORES_ONLY_LIVE_FILTER = 'LIVE_SCORES_ONLY_LIVE_FILTER';
export const SET_LIVE_SCORES_FILTER_REQUEST_OBJECT = 'SET_LIVE_SCORES_FILTER_REQUEST_OBJECT';
export const GET_LIVE_SCORES_CLEAR_ALL_FILTER = 'GET_LIVE_SCORES_CLEAR_ALL_FILTER';
export const GET_LIVE_SCORES_CLEAR_FILTER = 'GET_LIVE_SCORES_CLEAR_FILTER';


export const GET_LIVE_SCORES_HEADER_REQUEST = 'GET_LIVE_SCORES_HEADER_REQUEST';
export const GET_LIVE_SCORES_HEADER_SUCCESS = 'GET_LIVE_SCORES_HEADER_SUCCESS';
export const GET_LIVE_SCORES_HEADER_FAILURE = 'GET_LIVE_SCORES_HEADER_FAILURE';

export const GET_LIVE_SCORES_EVENTS_REQUEST = 'GET_LIVE_SCORES_EVENTS_REQUEST';
export const GET_LIVE_SCORES_EVENTS_SUCCESS = 'GET_LIVE_SCORES_EVENTS_SUCCESS';
export const GET_LIVE_SCORES_EVENTS_FAILURE = 'GET_LIVE_SCORES_EVENTS_FAILURE';

export const GET_LIVE_SCORES_EVENTS_UPDATE_FILTER = 'GET_LIVE_SCORES_EVENTS_UPDATE_FILTER';


export const LIVE_SCORES_ACTIVE_TYPE = 'LIVE_SCORES_ACTIVE_TYPE';

export const SUBSCRIBE_EVENT_SUCCESS = 'SUBSCRIBE_EVENT_SUCCESS';
export const SUBSCRIBE_EVENT_FAILURE = 'SUBSCRIBE_EVENT_FAILURE';

export const DELETE_SUBSCRIBE_EVENT_SUCCESS = 'DELETE_SUBSCRIBE_EVENT_SUCCESS';
export const DELETE_SUBSCRIBE_EVENT_FAILURE = 'DELETE_SUBSCRIBE_EVENT_FAILURE';

// SportsBook constans
export const SET_FAVORITES_FROM_LOCAL_STORAGE = 'SET_FAVORITES_FROM_LOCAL_STORAGE';
export const ADD_FAVORITE_EVENT = 'ADD_FAVORITE_EVENT';
export const REMOVE_FAVORITE_EVENT = 'REMOVE_FAVORITE_EVENT';

export const GET_SPORTSBOOK_TABS_REQUEST = 'GET_SPORTSBOOK_TABS_REQUEST';
export const GET_SPORTSBOOK_TABS_SUCCESS = 'GET_SPORTSBOOK_TABS_SUCCESS';
export const GET_SPORTSBOOK_TABS_FAILURE = 'GET_SPORTSBOOK_TABS_FAILURE';

export const GET_SPORTSBOOK_EVENTS_REQUEST = 'GET_SPORTSBOOK_EVENTS_REQUEST';
export const GET_SPORTSBOOK_EVENTS_SUCCESS = 'GET_SPORTSBOOK_EVENTS_SUCCESS';
export const GET_SPORTSBOOK_EVENTS_FAILURE = 'GET_SPORTSBOOK_EVENTS_FAILURE';

export const GET_POPULARORPERSONAL_EVENTS_REQUEST = 'GET_POPULARORPERSONAL_EVENTS_REQUEST';
export const GET_POPULARORPERSONAL_EVENTS_SUCCESS = 'GET_POPULARORPERSONAL_EVENTS_SUCCESS';
export const GET_POPULARORPERSONAL_EVENTS_FAILURE = 'GET_POPULARORPERSONAL_EVENTS_FAILURE';
export const VIEW_EVENT_LIST_MIXPANEL = 'VIEW_EVENT_LIST_MIXPANEL';

export const SET_SPORTSBOOK_ACTIVE_FILTERS = 'SET_SPORTSBOOK_ACTIVE_FILTERS';
export const SPORTSBOOK_FILTER_CLICKED = 'SPORTSBOOK_FILTER_CLICKED';

// Spor Toto Constans
export const SPOR_TOTO_COUPON_EARNINGS_REQUEST = 'SPOR_TOTO_COUPON_EARNINGS_REQUEST';
export const SPOR_TOTO_COUPON_EARNINGS_SUCCESS = 'SPOR_TOTO_COUPON_EARNINGS_SUCCESS';
export const SPOR_TOTO_COUPON_EARNINGS_FAILURE = 'SPOR_TOTO_COUPON_EARNINGS_FAILURE';

export const SPOR_TOTO_SLIP_TOGGLE = 'SPOR_TOTO_SLIP_TOGGLE';
export const SET_SPOR_TOTO_SLIP_DATA = 'SET_SPOR_TOTO_SLIP_DATA';
export const SPOR_TOTO_SLIP_RESET = 'SPOR_TOTO_SLIP_RESET';

export const SPOR_TOTO_COUPON_DETAIL_REQUEST = 'SPOR_TOTO_COUPON_DETAIL_REQUEST';
export const SPOR_TOTO_COUPON_DETAIL_SUCCESS = 'SPOR_TOTO_COUPON_DETAIL_SUCCESS';
export const SPOR_TOTO_COUPON_DETAIL_FAILURE = 'SPOR_TOTO_COUPON_DETAIL_FAILURE';

export const SPOR_TOTO_TOGGLE_SELECTION = 'SPOR_TOTO_TOGGLE_SELECTION';
export const SPOR_TOTO_SET_SELECTIONS = 'SPOR_TOTO_SET_SELECTIONS';
export const SPOR_TOTO_REMOVE_SELECTIONS = 'SPOR_TOTO_REMOVE_SELECTIONS';
export const SPOR_TOTO_RANDOM_SELECTIONS = 'SPOR_TOTO_RANDOM_SELECTIONS';
export const SPOR_TOTO_SET_POPULAR_SELECTIONS = 'SPOR_TOTO_SET_POPULAR_SELECTIONS';
export const SPOR_TOTO_GET_POPULAR_SELECTIONS = 'SPOR_TOTO_GET_POPULAR_SELECTIONS';

export const SPOR_TOTO_GET_EVENTS_REQUEST = 'SPOR_TOTO_GET_EVENTS_REQUEST';
export const SPOR_TOTO_GET_EVENTS_SUCCESS = 'SPOR_TOTO_GET_EVENTS_SUCCESS';
export const SPOR_TOTO_GET_EVENTS_FAILURE = 'SPOR_TOTO_GET_EVENTS_FAILURE';

export const SPOR_TOTO_GET_PLAY_RATIO_LIST_REQUEST = 'SPOR_TOTO_GET_PLAY_RATIO_LIST_REQUEST';
export const SPOR_TOTO_GET_PLAY_RATIO_LIST_SUCCESS = 'SPOR_TOTO_GET_PLAY_RATIO_LIST_SUCCESS';
export const SPOR_TOTO_GET_PLAY_RATIO_LIST_FAILURE = 'SPOR_TOTO_GET_PLAY_RATIO_LIST_FAILURE';

export const SPOR_TOTO_PLAY_REQUEST = 'SPOR_TOTO_PLAY_REQUEST';
export const SPOR_TOTO_PLAY_SUCCESS = 'SPOR_TOTO_PLAY_SUCCESS';
export const SPOR_TOTO_PLAY_FAILURE = 'SPOR_TOTO_PLAY_FAILURE';

export const SPOR_TOTO_SAVE_REQUEST = 'SPOR_TOTO_SAVE_REQUEST';
export const SPOR_TOTO_SAVE_SUCCESS = 'SPOR_TOTO_SAVE_SUCCESS';
export const SPOR_TOTO_SAVE_FAILURE = 'SPOR_TOTO_SAVE_FAILURE';

export const GET_SPOR_TOTO_HISTORY_LIST_REQUEST = 'GET_SPOR_TOTO_HISTORY_LIST_REQUEST';
export const GET_SPOR_TOTO_HISTORY_LIST_SUCCESS = 'GET_SPOR_TOTO_HISTORY_LIST_SUCCESS';
export const GET_SPOR_TOTO_HISTORY_LIST_FAILURE = 'GET_SPOR_TOTO_HISTORY_LIST_FAILURE';

export const SPOR_TOTO_CANCEL_COUPON_REQUEST = 'SPOR_TOTO_CANCEL_COUPON_REQUEST';
export const SPOR_TOTO_CANCEL_COUPON_SUCCESS = 'SPOR_TOTO_CANCEL_COUPON_SUCCESS';
export const SPOR_TOTO_CANCEL_COUPON_FAILURE = 'SPOR_TOTO_CANCEL_COUPON_FAILURE';

export const SPOR_TOTO_RESULT_REQUEST = 'SPOR_TOTO_RESULT_REQUEST';
export const SPOR_TOTO_RESULT_SUCCESS = 'SPOR_TOTO_RESULT_SUCCESS';
export const SPOR_TOTO_RESULT_FAILURE = 'SPOR_TOTO_RESULT_FAILURE';

export const SPOR_TOTO_RESULT_BY_WEEKLY_REQUEST = 'SPOR_TOTO_RESULT_BY_WEEKLY_REQUEST';
export const SPOR_TOTO_RESULT_BY_WEEKLY_SUCCESS = 'SPOR_TOTO_RESULT_BY_WEEKLY_SUCCESS';
export const SPOR_TOTO_RESULT_BY_WEEKLY_FAILURE = 'SPOR_TOTO_RESULT_BY_WEEKLY_FAILURE';

export const SPOR_TOTO_COUPONS_REQUEST = 'SPOR_TOTO_COUPONS_REQUEST';
export const SPOR_TOTO_COUPONS_RESET = 'SPOR_TOTO_COUPONS_RESET';
export const SPOR_TOTO_COUPONS_SUCCESS = 'SPOR_TOTO_COUPONS_SUCCESS';
export const SPOR_TOTO_COUPONS_FAILURE = 'SPOR_TOTO_COUPONS_FAILURE';

export const GET_SPOR_TOTO_COUNT_DOWN = 'GET_SPOR_TOTO_COUNT_DOWN';
export const GET_SPOR_TOTO_COUNT_DOWN_SUCCESS = 'GET_SPOR_TOTO_COUNT_DOWN_SUCCESS';
export const GET_SPOR_TOTO_COUNT_DOWN_FAILURE = 'GET_SPOR_TOTO_COUNT_DOWN_FAILURE';

export const SPOR_TOTO_DELETE_SAVED_COUPON_REQUEST = 'SPOR_TOTO_DELETE_SAVED_COUPON_REQUEST';
export const SPOR_TOTO_DELETE_SAVED_COUPON_SUCCESS = 'SPOR_TOTO_DELETE_SAVED_COUPON_SUCCESS';
export const SPOR_TOTO_DELETE_SAVED_COUPON_FAILURE = 'SPOR_TOTO_DELETE_SAVED_COUPON_FAILURE';

export const SPOR_TOTO_UPDATE_SAVED_COUPON_REQUEST = 'SPOR_TOTO_UPDATE_SAVED_COUPON_REQUEST';
export const SPOR_TOTO_UPDATE_SAVED_COUPON_SUCCESS = 'SPOR_TOTO_UPDATE_SAVED_COUPON_SUCCESS';
export const SPOR_TOTO_UPDATE_SAVED_COUPON_FAILURE = 'SPOR_TOTO_UPDATE_SAVED_COUPON_FAILURE';


// Bank Account
export const GET_BANK_ACCOUNTS_REQUEST = 'GET_BANK_ACCOUNTS_REQUEST';
export const GET_BANK_ACCOUNTS_SUCCESS = 'GET_BANK_ACCOUNTS_SUCCESS';
export const GET_BANK_ACCOUNTS_FAILURE = 'GET_BANK_ACCOUNTS_FAILURE';

export const DELETE_BANK_ACCOUNT_SUCCESS = 'DELETE_BANK_ACCOUNT_SUCCESS';
export const DELETE_BANK_ACCOUNT_FAILURE = 'DELETE_BANK_ACCOUNT_FAILURE';

export const GET_BANK_TRANSACTIONS_REQUEST = 'GET_BANK_TRANSACTIONS_REQUEST';
export const GET_BANK_TRANSACTIONS_SUCCESS = 'GET_BANK_TRANSACTIONS_SUCCESS';
export const GET_BANK_TRANSACTIONS_FAILURE = 'GET_BANK_TRANSACTIONS_FAILURE';

export const CANCEL_BANK_TRANSACTION_SUCCESS = 'CANCEL_BANK_TRANSACTION_SUCCESS';
export const CANCEL_BANK_TRANSACTION_FAILURE = 'CANCEL_BANK_TRANSACTION_FAILURE';

export const GET_DETAILED_BALANCE_REQUEST = 'GET_DETAILED_BALANCE_REQUEST';
export const GET_DETAILED_BALANCE_SUCCESS = 'GET_DETAILED_BALANCE_SUCCESS';
export const GET_DETAILED_BALANCE_FAILURE = 'GET_DETAILED_BALANCE_FAILURE';

//Get profile communications settings
export const GET_COMMUNICATION_SETTINGS_REQUEST = 'GET_COMMUNICATION_SETTINGS_REQUEST';
export const GET_COMMUNICATION_SETTINGS_SUCCESS = 'GET_COMMUNICATION_SETTINGS_SUCCESS';
export const GET_COMMUNICATION_SETTINGS_FAILURE = 'GET_COMMUNICATION_SETTINGS_FAILURE';

export const GET_DISPLAY_COMMUNICATION_SETTINGS_REQUEST = 'GET_DISPLAY_COMMUNICATION_SETTINGS_REQUEST';
export const GET_DISPLAY_COMMUNICATION_SETTINGS_SUCCESS = 'GET_DISPLAY_COMMUNICATION_SETTINGS_SUCCESS';
export const GET_DISPLAY_COMMUNICATION_SETTINGS_FAILURE = 'GET_DISPLAY_COMMUNICATION_SETTINGS_FAILURE';

//Put profile communications settings
export const UPDATE_COMMUNICATION_SETTINGS_REQUEST = 'UPDATE_COMMUNICATION_SETTINGS_REQUEST';
export const UPDATE_COMMUNICATION_SETTINGS_SUCCESS = 'UPDATE_COMMUNICATION_SETTINGS_SUCCESS';
export const UPDATE_COMMUNICATION_SETTINGS_FAILURE = 'UPDATE_COMMUNICATION_SETTINGS_FAILURE';

export const GET_ANNOUNCEMENT_DATA_REQUEST = 'GET_ANNOUNCEMENT_DATA_REQUEST';
export const GET_ANNOUNCEMENT_DATA_SUCCESS = 'GET_ANNOUNCEMENT_DATA_SUCCESS';
export const GET_ANNOUNCEMENT_DATA_FAILURE = 'GET_ANNOUNCEMENT_DATA_FAILURE';

export const GET_ANNOUNCEMENT_DETAIL_REQUEST = 'GET_ANNOUNCEMENT_DETAIL_REQUEST';
export const GET_ANNOUNCEMENT_DETAIL_SUCCESS = 'GET_ANNOUNCEMENT_DETAIL_SUCCESS';
export const GET_ANNOUNCEMENT_DETAIL_FAILURE = 'GET_ANNOUNCEMENT_DETAIL_FAILURE';

export const SET_SEEN_ANNOUNCEMENT_REQUEST = 'SET_SEEN_ANNOUNCEMENT_REQUEST';
export const SET_SEEN_ANNOUNCEMENT_SUCCESS = 'SET_SEEN_ANNOUNCEMENT_SUCCESS';
export const SET_SEEN_ANNOUNCEMENT_FAILURE = 'SET_SEEN_ANNOUNCEMENT_FAILURE';

export const GET_SEEN_ANNOUNCEMENT_COUNT_SUCCESS = 'GET_SEEN_ANNOUNCEMENT_COUNT_SUCCESS';

export const GET_READ_ANNOUNCEMENT_COUNT_REQUEST = 'GET_READ_ANNOUNCEMENT_COUNT_REQUEST';
export const GET_READ_ANNOUNCEMENT_COUNT_SUCCESS = 'GET_READ_ANNOUNCEMENT_COUNT_SUCCESS';
export const GET_READ_ANNOUNCEMENT_COUNT_FAILURE = 'GET_READ_ANNOUNCEMENT_COUNT_FAILURE';

export const SET_READ_ALL_ANNOUNCEMENT_REQUEST = 'SET_READ_ALL_ANNOUNCEMENT_REQUEST';
export const SET_READ_ALL_ANNOUNCEMENT_SUCCESS = 'SET_READ_ALL_ANNOUNCEMENT_SUCCESS';
export const SET_READ_ALL_ANNOUNCEMENT_FAILURE = 'SET_READ_ALL_ANNOUNCEMENT_FAILURE';

//Get personal informations settings
export const GET_PERSONAL_INFORMATIONS_REQUEST = 'GET_PERSONAL_INFORMATIONS_REQUEST';
export const GET_PERSONAL_INFORMATIONS_SUCCESS = 'GET_PERSONAL_INFORMATIONS_SUCCESS';
export const GET_PERSONAL_INFORMATIONS_FAILURE = 'GET_PERSONAL_INFORMATIONS_FAILURE';

//Put personal informations gender
export const UPDATE_PERSONAL_INFORMATIONS_GENDER_REQUEST = 'UPDATE_PERSONAL_INFORMATIONS_GENDER_REQUEST';
export const UPDATE_PERSONAL_INFORMATIONS_GENDER_SUCCESS = 'UPDATE_PERSONAL_INFORMATIONS_GENDER_SUCCESS';
export const UPDATE_PERSONAL_INFORMATIONS_GENDER_FAILURE = 'UPDATE_PERSONAL_INFORMATIONS_GENDER_FAILURE';

//Put personal informations phone
export const UPDATE_PERSONAL_INFORMATIONS_PHONE_REQUEST = 'UPDATE_PERSONAL_INFORMATIONS_PHONE_REQUEST';
export const UPDATE_PERSONAL_INFORMATIONS_PHONE_SUCCESS = 'UPDATE_PERSONAL_INFORMATIONS_PHONE_SUCCESS';
export const UPDATE_PERSONAL_INFORMATIONS_PHONE_FAILURE = 'UPDATE_PERSONAL_INFORMATIONS_PHONE_FAILURE';

export const UPDATE_PERSONAL_INFORMATIONS_EMAIL_BY_OTP_REQUEST = 'UPDATE_PERSONAL_INFORMATIONS_EMAIL_BY_OTP_REQUEST';
export const UPDATE_PERSONAL_INFORMATIONS_EMAIL_BY_OTP_SUCCESS = 'UPDATE_PERSONAL_INFORMATIONS_EMAIL_BY_OTP_SUCCESS';
export const UPDATE_PERSONAL_INFORMATIONS_EMAIL_BY_OTP_FAILURE = 'UPDATE_PERSONAL_INFORMATIONS_EMAIL_BY_OTP_FAILURE';

//Put personal informations email
export const UPDATE_PERSONAL_INFORMATIONS_EMAIL_REQUEST = 'UPDATE_PERSONAL_INFORMATIONS_EMAIL_REQUEST';
export const UPDATE_PERSONAL_INFORMATIONS_EMAIL_SUCCESS = 'UPDATE_PERSONAL_INFORMATIONS_EMAIL_SUCCESS';
export const UPDATE_PERSONAL_INFORMATIONS_EMAIL_FAILURE = 'UPDATE_PERSONAL_INFORMATIONS_EMAIL_FAILURE';

//Put personal informations city
export const UPDATE_PERSONAL_INFORMATIONS_CITY_REQUEST = 'UPDATE_PERSONAL_INFORMATIONS_CITY_REQUEST';
export const UPDATE_PERSONAL_INFORMATIONS_CITY_SUCCESS = 'UPDATE_PERSONAL_INFORMATIONS_CITY_SUCCESS';
export const UPDATE_PERSONAL_INFORMATIONS_CITY_FAILURE = 'UPDATE_PERSONAL_INFORMATIONS_CITY_FAILURE';

export const POST_CONTACT_US_FORM_REQUEST = 'POST_CONTACT_US_FORM_REQUEST';
export const POST_CONTACT_US_FORM_SUCCESS = 'POST_CONTACT_US_FORM_SUCCESS';
export const POST_CONTACT_US_FORM_FAILURE = 'POST_CONTACT_US_FORM_FAILURE';

export const GET_CONTACT_US_CATEGORIES_REQUEST = 'GET_CONTACT_US_CATEGORIES_REQUEST';
export const GET_CONTACT_US_CATEGORIES_SUCCESS = 'GET_CONTACT_US_CATEGORIES_SUCCESS';
export const GET_CONTACT_US_CATEGORIES_FAILURE = 'GET_CONTACT_US_CATEGORIES_FAILURE';

export const GET_AUTH_CONTACT_US_CATEGORIES_REQUEST = 'GET_AUTH_CONTACT_US_CATEGORIES_REQUEST';
export const GET_AUTH_CONTACT_US_CATEGORIES_SUCCESS = 'GET_AUTH_CONTACT_US_CATEGORIES_SUCCESS';
export const GET_AUTH_CONTACT_US_CATEGORIES_FAILURE = 'GET_AUTH_CONTACT_US_CATEGORIES_FAILURE';

export const GET_CAPTCHA_HASH_REQUEST = 'GET_CAPTCHA_HASH_REQUEST';
export const GET_CAPTCHA_HASH_SUCCESS = 'GET_CAPTCHA_HASH_SUCCESS';
export const GET_CAPTCHA_HASH_FAILURE = 'GET_CAPTCHA_HASH_FAILURE';

export const CAPTCHA_VERIFY_REQUEST = 'CAPTCHA_VERIFY_REQUEST';
export const CAPTCHA_VERIFY_SUCCESS = 'CAPTCHA_VERIFY_SUCCESS';
export const CAPTCHA_VERIFY_FAILURE = 'CAPTCHA_VERIFY_FAILURE';

export const GET_CONTACT_US_SUBCATEGORIES_REQUEST = 'GET_CONTACT_US_SUBCATEGORIES_REQUEST';
export const GET_CONTACT_US_SUBCATEGORIES_SUCCESS = 'GET_CONTACT_US_SUBCATEGORIES_SUCCESS';
export const GET_CONTACT_US_SUBCATEGORIES_FAILURE = 'GET_CONTACT_US_SUBCATEGORIES_FAILURE';

export const UPDATE_USER_DETAILS_REQUEST = 'UPDATE_USER_DETAILS_REQUEST';
export const UPDATE_USER_DETAILS_SUCCESS = 'UPDATE_USER_DETAILS_SUCCESS';
export const UPDATE_USER_DETAILS_FAILURE = 'UPDATE_USER_DETAILS_FAILURE';

export const UPDATE_USER_BETSLIP_SETTINGS_REQUEST = 'UPDATE_USER_BETSLIP_SETTINGS_REQUEST';
export const UPDATE_USER_BETSLIP_SETTINGS_SUCCESS = 'UPDATE_USER_BETSLIP_SETTINGS_SUCCESS';
export const UPDATE_USER_BETSLIP_SETTINGS_FAILURE = 'UPDATE_USER_BETSLIP_SETTINGS_FAILURE';

export const UPDATE_USER_BALANCE_REQUEST = 'UPDATE_USER_BALANCE_REQUEST';
export const UPDATE_USER_BALANCE_SUCCESS = 'UPDATE_USER_BALANCE_SUCCESS';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_BALANCE_FAILURE = 'UPDATE_USER_BALANCE_FAILURE';
export const UPDATE_USER_AMOUNT_INFO_LIST_SUCCESS = 'UPDATE_USER_AMOUNT_INFO_LIST_SUCCESS';
export const UPDATE_USER_DIGITALGAMES_BALANCE_SUCCESS = 'UPDATE_USER_DIGITALGAMES_BALANCE_SUCCESS';

export const GET_SYSTEM_COUPONS_REQUEST = 'GET_SYSTEM_COUPONS_REQUEST';
export const GET_SYSTEM_COUPONS_SUCCESS = 'GET_SYSTEM_COUPONS_SUCCESS';
export const GET_SYSTEM_COUPONS_FAILURE = 'GET_SYSTEM_COUPONS_FAILURE';

export const RESET_SYSTEM_COUPONS = 'RESET_SYSTEM_COUPONS';

export const GET_CONTINUED_COUPONS_REQUEST = 'GET_CONTINUED_COUPONS_REQUEST';
export const GET_CONTINUED_COUPONS_SUCCESS = 'GET_CONTINUED_COUPONS_SUCCESS';
export const GET_CONTINUED_COUPONS_FAILURE = 'GET_CONTINUED_COUPONS_FAILURE';
export const RESET_CONTINUED_COUPONS_PAGINATION = 'RESET_CONTINUED_COUPONS_PAGINATION';

export const GET_WON_COUPONS_REQUEST = 'GET_WON_COUPONS_REQUEST';
export const GET_WON_COUPONS_SUCCESS = 'GET_WON_COUPONS_SUCCESS';
export const GET_WON_COUPONS_FAILURE = 'GET_WON_COUPONS_FAILURE';
export const RESET_WON_COUPONS_PAGINATION = 'RESET_WON_COUPONS_PAGINATION';

export const GET_LOST_COUPONS_REQUEST = 'GET_LOST_COUPONS_REQUEST';
export const GET_LOST_COUPONS_SUCCESS = 'GET_LOST_COUPONS_SUCCESS';
export const GET_LOST_COUPONS_FAILURE = 'GET_LOST_COUPONS_FAILURE';
export const RESET_LOST_COUPONS_PAGINATION = 'RESET_LOST_COUPONS_PAGINATION';

export const GET_SAVED_COUPONS_REQUEST = 'GET_SAVED_COUPONS_REQUEST';
export const GET_SAVED_COUPONS_SUCCESS = 'GET_SAVED_COUPONS_SUCCESS';
export const GET_SAVED_COUPONS_FAILURE = 'GET_SAVED_COUPONS_FAILURE';
export const RESET_SAVED_COUPONS_PAGINATION = 'RESET_SAVED_COUPONS_PAGINATION';

export const GET_COUPON_DETAIL_REQUEST = 'GET_COUPON_DETAIL_REQUEST';
export const GET_COUPON_DETAIL_SUCCESS = 'GET_COUPON_DETAIL_SUCCESS';
export const GET_COUPON_DETAIL_FAILURE = 'GET_COUPON_DETAIL_FAILURE';

export const GET_COUPON_CHANGE_ODDS_REQUEST = 'GET_COUPON_CHANGE_ODDS_REQUEST';
export const GET_COUPON_CHANGE_ODDS_SUCCESS = 'GET_COUPON_CHANGE_ODDS_SUCCESS';
export const GET_COUPON_CHANGE_ODDS_FAILURE = 'GET_COUPON_CHANGE_ODDS_FAILURE';

export const GET_REJECTED_COUPONS_REQUEST = 'GET_REJECTED_COUPONS_REQUEST';
export const GET_REJECTED_COUPONS_SUCCESS = 'GET_REJECTED_COUPONS_SUCCESS';
export const GET_REJECTED_COUPONS_FAILURE = 'GET_REJECTED_COUPONS_FAILURE';
export const RESET_REJECTED_COUPONS_PAGINATION = 'RESET_REJECTED_COUPONS_PAGINATION';

export const GET_EVENT_STATUS_UPDATE_REQUEST = 'GET_EVENT_STATUS_UPDATE_REQUEST';
export const GET_EVENT_STATUS_UPDATE_SUCCESS = 'GET_EVENT_STATUS_UPDATE_SUCCESS';
export const GET_EVENT_STATUS_UPDATE_FAILURE = 'GET_EVENT_STATUS_UPDATE_FAILURE';

export const SET_COUPONS_ACTIVE_FILTER = 'SET_COUPONS_ACTIVE_FILTER';

export const GET_THROWBACK_COUPON_REQUEST = 'GET_THROWBACK_COUPON_REQUEST';
export const GET_THROWBACK_COUPON_SUCCESS = 'GET_THROWBACK_COUPON_SUCCESS';
export const GET_THROWBACK_COUPON_FAILURE = 'GET_THROWBACK_COUPON_FAILURE';

// Super System
export const SUPER_SYSTEM_COUPONS_REQUEST = 'SUPER_SYSTEM_COUPONS_REQUEST';
export const SUPER_SYSTEM_COUPONS_SUCCESS = 'SUPER_SYSTEM_COUPONS_SUCCESS';
export const SUPER_SYSTEM_COUPONS_FAILURE = 'SUPER_SYSTEM_COUPONS_FAILURE';

export const SUPER_SYSTEM_VALIDATE_REQUEST = 'SUPER_SYSTEM_VALIDATE_REQUEST';
export const SUPER_SYSTEM_VALIDATE_SUCCESS = 'SUPER_SYSTEM_VALIDATE_SUCCESS';
export const SUPER_SYSTEM_VALIDATE_FAILURE = 'SUPER_SYSTEM_VALIDATE_FAILURE';

export const SUPER_SYSTEM_BETSLIP_COUPONS_REQUEST = 'SUPER_SYSTEM_BETSLIP_COUPONS_REQUEST';
export const SUPER_SYSTEM_BETSLIP_COUPONS_SUCCESS = 'SUPER_SYSTEM_BETSLIP_COUPONS_SUCCESS';
export const SUPER_SYSTEM_BETSLIP_COUPONS_FAILURE = 'SUPER_SYSTEM_BETSLIP_COUPONS_FAILURE';

export const SUPER_SYSTEM_BETSLIP_SUMMARY_REQUEST = 'SUPER_SYSTEM_BETSLIP_SUMMARY_REQUEST';
export const SUPER_SYSTEM_BETSLIP_SUMMARY_SUCCESS = 'SUPER_SYSTEM_BETSLIP_SUMMARY_SUCCESS';
export const SUPER_SYSTEM_BETSLIP_SUMMARY_FAILURE = 'SUPER_SYSTEM_BETSLIP_SUMMARY_FAILURE';

export const SUPER_SYSTEM_PLAYED_COUPONS_REQUEST = 'SUPER_SYSTEM_PLAYED_COUPONS_REQUEST';
export const SUPER_SYSTEM_PLAYED_COUPONS_SUCCESS = 'SUPER_SYSTEM_PLAYED_COUPONS_SUCCESS';
export const SUPER_SYSTEM_PLAYED_COUPONS_FAILURE = 'SUPER_SYSTEM_PLAYED_COUPONS_FAILURE';

export const DELETE_COUPON_BY_ID_REQUEST = 'DELETE_COUPON_BY_ID_REQUEST';
export const DELETE_COUPON_BY_ID_SUCCESS = 'DELETE_COUPON_BY_ID_SUCCESS';
export const DELETE_COUPON_BY_ID_FAILURE = 'DELETE_COUPON_BY_ID_FAILURE';

export const DELETE_SAVED_COUPON_BY_ID_REQUEST = 'DELETE_SAVED_COUPON_BY_ID_REQUEST';
export const DELETE_SAVED_COUPON_BY_ID_SUCCESS = 'DELETE_SAVED_COUPON_BY_ID_SUCCESS';
export const DELETE_SAVED_COUPON_BY_ID_FAILURE = 'DELETE_SAVED_COUPON_BY_ID_FAILURE';

export const GET_OUT_RIGHT_CONTINUE_COUPONS_REQUEST = 'GET_OUT_RIGHT_CONTINUE_COUPONS_REQUEST';
export const GET_OUT_RIGHT_CONTINUE_COUPONS_SUCCESS = 'GET_OUT_RIGHT_CONTINUE_COUPONS_SUCCESS';
export const GET_OUT_RIGHT_CONTINUE_COUPONS_FAILURE = 'GET_OUT_RIGHT_CONTINUE_COUPONS_FAILURE';
export const RESET_OUT_RIGHT_CONTINUE_PAGINATION = 'RESET_OUT_RIGHT_CONTINUE_PAGINATION';

export const GET_OUT_RIGHT_WON_COUPONS_REQUEST = 'GET_OUT_RIGHT_WON_COUPONS_REQUEST';
export const GET_OUT_RIGHT_WON_COUPONS_SUCCESS = 'GET_OUT_RIGHT_WON_COUPONS_SUCCESS';
export const GET_OUT_RIGHT_WON_COUPONS_FAILURE = 'GET_OUT_RIGHT_WON_COUPONS_FAILURE';
export const RESET_OUT_RIGHT_WON_PAGINATION = 'RESET_OUT_RIGHT_WON_PAGINATION';

export const SEND_RATE_INFORMATION_REQUEST = 'SEND_RATE_INFORMATION_REQUEST';
export const SEND_RATE_INFORMATION_SUCCESS = 'SEND_RATE_INFORMATION_SUCCESS';
export const SEND_RATE_INFORMATION_FAILURE = 'SEND_RATE_INFORMATION_FAILURE';

export const GET_OUT_RIGHT_LOST_COUPONS_REQUEST = 'GET_OUT_RIGHT_LOST_COUPONS_REQUEST';
export const GET_OUT_RIGHT_LOST_COUPONS_SUCCESS = 'GET_OUT_RIGHT_LOST_COUPONS_SUCCESS';
export const GET_OUT_RIGHT_LOST_COUPONS_FAILURE = 'GET_OUT_RIGHT_LOST_COUPONS_FAILURE';
export const RESET_OUT_RIGHT_LOST_PAGINATION = 'RESET_OUT_RIGHT_LOST_PAGINATION';

export const GET_OUT_RIGHT_SAVED_COUPONS_REQUEST = 'GET_OUT_RIGHT_SAVED_COUPONS_REQUEST';
export const GET_OUT_RIGHT_SAVED_COUPONS_SUCCESS = 'GET_OUT_RIGHT_SAVED_COUPONS_SUCCESS';
export const GET_OUT_RIGHT_SAVED_COUPONS_FAILURE = 'GET_OUT_RIGHT_SAVED_COUPONS_FAILURE';
export const RESET_OUT_RIGHT_SAVED_PAGINATION = 'RESET_OUT_RIGHT_SAVED_PAGINATION';

export const EVENT_SCORES_REQUEST = 'EVENT_SCORES_REQUEST';
export const EVENT_SCORES_SUCCESS = 'EVENT_SCORES_SUCCESS';
export const EVENT_SCORES_FAILURE = 'EVENT_SCORES_FAILURE';

export const SET_USER_KEY_REQUEST = 'SET_USER_KEY_REQUEST';
export const SET_USER_KEY_SUCCESS = 'SET_USER_KEY_SUCCESS';
export const SET_USER_KEY_FAILURE = 'SET_USER_KEY_FAILURE';

export const GET_USER_KEY_REQUEST = 'GET_USER_KEY_REQUEST';
export const GET_USER_KEY_SUCCESS = 'GET_USER_KEY_SUCCESS';
export const GET_USER_KEY_FAILURE = 'GET_USER_KEY_FAILURE';

export const SET_USER_KEY_FROM_LOCAL_STORAGE = 'SET_USER_KEY_FROM_LOCAL_STORAGE';

export const MIN_SEARCH_CHAR_LENGTH = 1;

export const MULTIPLIER_MIN_VALUE = EnvironmentManager.getParameter('TM_MIN_STAKE') || 1;
export const MULTIPLIER_MAX_VALUE = EnvironmentManager.getParameter('TM_MAX_STAKE') || 11001;

export const MULTIPLIER_VALID_MIN_VALUE_STATIC = +EnvironmentManager.getParameter('TM_MIN_STAKE_WAGER_TMPRO') || 50;

export const MULTIPLE_COUPON_COUNT_MIN_VALUE = 1;
export const MULTIPLE_COUPON_COUNT_MAX_VALUE = +EnvironmentManager.getParameter('max_multi_coupon') || 1000;
export const MULTIPLE_COUPON_COUNT_MAX_VALUE_LIVE = +EnvironmentManager.getParameter('max_multi_coupon_live') || 1000;

export const CONTINUED_COUPONS_REQUEST_ADDITIONAL_TIME = 180000; // 3min

export const MULTIPLE_COUPON_BUTTON_VISIBLE = EnvironmentManager.getParameter('mutual_coupon_visible');
export const MULTIPLE_COUPON_BUTTON_VISIBLE_LIVE = EnvironmentManager.getParameter('live_mutual_coupon_visible');

// TJK BETSLIP
export const TJK_MULTIPLIER_MIN_VALUE = 1;
export const TJK_MULTIPLIER_MAX_VALUE = 99999;

export const TJK_MULTIPLE_COUPON_COUNT_MIN_VALUE = 1;
export const TJK_MULTIPLE_COUPON_COUNT_MAX_VALUE = +EnvironmentManager.getMessageText({ key: 'tjk_multi_coupon' }) || 10;

//Websocket constants
export const SPORTSBOOK_EVENTS_WS_UPDATE = 'SPORTSBOOK_EVENTS_WS_UPDATE';
export const SPORTSBOOK_EVENTS_WS_REMOVE = 'SPORTSBOOK_EVENTS_WS_REMOVE';
export const SPORTSBOOK_BETTING_WS_STATUS_TOGGLE = 'SPORTSBOOK_BETTING_WS_STATUS_TOGGLE';

export const LIVE_SCORES_WS_UPDATE = 'LIVE_SCORES_WS_UPDATE';
export const WIN_LOSE_STATUS_WS_UPDATE = 'WIN_LOSE_STATUS_WS_UPDATE';

export const POPULAR_BETS_WS_EVENT_REMOVE = 'POPULAR_BETS_WS_EVENT_REMOVE';
export const POPULAR_BETS_WS_ODD_UPDATE = 'POPULAR_BETS_WS_ODD_UPDATE';

export const BETSLIP_EVENT_VERSION_WS_UPDATE = 'BETSLIP_EVENT_VERSION_WS_UPDATE';
export const BETSLIP_EVENT_ODD_WS_UPDATE = 'BETSLIP_EVENT_ODD_WS_UPDATE';
export const BETSLIP_EVENT_BETTING_WS_STATUS_TOGGLE = 'BETSLIP_EVENT_BETTING_WS_STATUS_TOGGLE';

export const MATCH_CARD_ODDS_WS_UPDATE = 'MATCH_CARD_ODDS_WS_UPDATE';

export const MATCH_CARD_EVENT_UPDATE = 'MATCH_CARD_EVENT_UPDATE';
export const MATCH_CARD_EVENT_REMOVED = 'MATCH_CARD_EVENT_REMOVED';
export const MATCH_CARD_EVENT_ADDED = 'MATCH_CARD_EVENT_ADDED';

export const ADD_EVENT_TO_BETSLIP_TOAST_MESSAGE_RESET = 'ADD_EVENT_TO_BETSLIP_TOAST_MESSAGE_RESET';

export const GET_POPULAR_BETS_REQUEST = 'GET_POPULAR_BETS_REQUEST';
export const GET_POPULAR_BETS_SUCCESS = 'GET_POPULAR_BETS_SUCCESS';
export const GET_POPULAR_BETS_FAILURE = 'GET_POPULAR_BETS_FAILURE';

export const GET_HOMEPAGE_POPULAR_BETS_REQUEST = 'GET_HOMEPAGE_POPULAR_BETS_REQUEST';
export const GET_HOMEPAGE_POPULAR_BETS_SUCCESS = 'GET_HOMEPAGE_POPULAR_BETS_SUCCESS';
export const GET_HOMEPAGE_POPULAR_BETS_FAILURE = 'GET_HOMEPAGE_POPULAR_BETS_FAILURE';

export const TOP_POPULAR_BETS_WS_ODD_UPDATE = 'TOP_POPULAR_BETS_WS_ODD_UPDATE';

export const POPULAR_EVENT_CLIENT_FILTER = 'POPULAR_EVENT_CLIENT_FILTER';

export const GET_ALL_CATEGORIES_LIST_REQUEST = 'GET_ALL_CATEGORIES_LIST_REQUEST';
export const GET_ALL_CATEGORIES_LIST_SUCCESS = 'GET_ALL_CATEGORIES_LIST_SUCCESS';
export const GET_ALL_CATEGORIES_LIST_FAILURE = 'GET_ALL_CATEGORIES_LIST_FAILURE';

export const GET_GIFT_INFORMATIONS_REQUEST = 'GET_GIFT_INFORMATIONS_REQUEST';
export const GET_GIFT_INFORMATIONS_SUCCESS = 'GET_GIFT_INFORMATIONS_SUCCESS';
export const GET_GIFT_INFORMATIONS_FAILURE = 'GET_GIFT_INFORMATIONS_FAILURE';

export const UPDATE_GIFT_INFORMATIONS_REQUEST = 'UPDATE_GIFT_INFORMATIONS_REQUEST';
export const UPDATE_GIFT_INFORMATIONS_SUCCESS = 'UPDATE_GIFT_INFORMATIONS_SUCCESS';
export const UPDATE_GIFT_INFORMATIONS_FAILURE = 'UPDATE_GIFT_INFORMATIONS_FAILURE';

export const GET_CITIES_TEAMS_REQUEST = 'GET_CITIES_TEAMS_REQUEST';
export const GET_CITIES_TEAMS_SUCCESS = 'GET_CITIES_TEAMS_SUCCESS';
export const GET_CITIES_TEAMS_FAILURE = 'GET_CITIES_TEAMS_FAILURE';

export const GET_GIFT_AGREEMENT_REQUEST = 'GET_GIFT_AGREEMENT_REQUEST';
export const GET_GIFT_AGREEMENT_SUCCESS = 'GET_GIFT_AGREEMENT_SUCCESS';
export const GET_GIFT_AGREEMENT_FAILURE = 'GET_GIFT_AGREEMENT_FAILURE';

export const GET_ODD_HISTORY_REQUEST = 'GET_ODD_HISTORY_REQUEST';
export const GET_ODD_HISTORY_SUCCESS = 'GET_ODD_HISTORY_SUCCESS';
export const GET_ODD_HISTORY_FAILURE = 'GET_ODD_HISTORY_FAILURE';

export const SET_LIVE_STREAM_START = 'SET_LIVE_STREAM_START';
export const SET_LIVE_STREAM_STOP = 'SET_LIVE_STREAM_STOP';
export const SET_TJK_LIVE_STREAM_START = 'SET_TJK_LIVE_STREAM_START';
export const SET_TJK_LIVE_STREAM_STOP = 'SET_TJK_LIVE_STREAM_STOP';

export const GET_MATCH_CARD_LEAGUE_EVENTS_REQUEST = 'GET_MATCH_CARD_LEAGUE_EVENTS_REQUEST';
export const GET_MATCH_CARD_LEAGUE_EVENTS_SUCCESS = 'GET_MATCH_CARD_LEAGUE_EVENTS_SUCCESS';
export const GET_MATCH_CARD_LEAGUE_EVENTS_FAILURE = 'GET_MATCH_CARD_LEAGUE_EVENTS_FAILURE';

export const GET_MATCH_CARD_STATISTIC_MARKETS_REQUEST = 'GET_MATCH_CARD_STATISTIC_MARKETS_REQUEST';
export const GET_MATCH_CARD_STATISTIC_MARKETS_SUCCESS = 'GET_MATCH_CARD_STATISTIC_MARKETS_SUCCESS';
export const GET_MATCH_CARD_STATISTIC_MARKETS_FAILURE = 'GET_MATCH_CARD_STATISTIC_MARKETS_FAILURE';

export const GET_MATCH_CARD_EVENT_REQUEST = 'GET_MATCH_CARD_EVENT_REQUEST';
export const GET_MATCH_CARD_EVENT_SUCCESS = 'GET_MATCH_CARD_EVENT_SUCCESS';
export const GET_MATCH_CARD_EVENT_FAILURE = 'GET_MATCH_CARD_EVENT_FAILURE';

export const GET_CLICKED_POINT = 'GET_CLICKED_POINT';

export const EMAIL_VERIFY_SUCCESS = 'EMAIL_VERIFY_SUCCESS';

export const GET_MATCH_CARD_TRIBUN_COUPONS_REQUEST = 'GET_MATCH_CARD_TRIBUN_COUPONS_REQUEST';
export const GET_MATCH_CARD_TRIBUN_COUPONS_SUCCESS = 'GET_MATCH_CARD_TRIBUN_COUPONS_SUCCESS';
export const GET_MATCH_CARD_TRIBUN_COUPONS_FAILURE = 'GET_MATCH_CARD_TRIBUN_COUPONS_FAILURE';
export const SET_MATCHCARD_LAST_FEEDS = 'SET_MATCHCARD_LAST_FEEDS';

export const GET_MATCH_CARD_HOT_BETS_REQUEST = 'GET_MATCH_CARD_HOT_BETS_REQUEST';
export const GET_MATCH_CARD_HOT_BETS_SUCCESS = 'GET_MATCH_CARD_HOT_BETS_SUCCESS';
export const GET_MATCH_CARD_HOT_BETS_FAILURE = 'GET_MATCH_CARD_HOT_BETS_FAILURE';
export const MATCH_CARD_HOT_BETS_WS_UPDATE = 'MATCH_CARD_HOT_BETS_WS_UPDATE';

// Bahista 2.0 — MatchCard tab
export const CHECK_BAHISTA_ANALYSIS_REQUEST = 'CHECK_BAHISTA_ANALYSIS_REQUEST';
export const CHECK_BAHISTA_ANALYSIS_SUCCESS = 'CHECK_BAHISTA_ANALYSIS_SUCCESS';
export const CHECK_BAHISTA_ANALYSIS_FAILURE = 'CHECK_BAHISTA_ANALYSIS_FAILURE';

export const GET_BAHISTA_PREDICTIONS_REQUEST = 'GET_BAHISTA_PREDICTIONS_REQUEST';
export const GET_BAHISTA_PREDICTIONS_SUCCESS = 'GET_BAHISTA_PREDICTIONS_SUCCESS';
export const GET_BAHISTA_PREDICTIONS_FAILURE = 'GET_BAHISTA_PREDICTIONS_FAILURE';

export const RUN_BAHISTA_ANALYZE_REQUEST = 'RUN_BAHISTA_ANALYZE_REQUEST';
export const RUN_BAHISTA_ANALYZE_SUCCESS = 'RUN_BAHISTA_ANALYZE_SUCCESS';
export const RUN_BAHISTA_ANALYZE_FAILURE = 'RUN_BAHISTA_ANALYZE_FAILURE';

export const CLEAR_BAHISTA_STATE = 'CLEAR_BAHISTA_STATE';

export const GET_BAHISTA_AUTHOR_REQUEST = 'GET_BAHISTA_AUTHOR_REQUEST';
export const GET_BAHISTA_AUTHOR_SUCCESS = 'GET_BAHISTA_AUTHOR_SUCCESS';
export const GET_BAHISTA_AUTHOR_FAILURE = 'GET_BAHISTA_AUTHOR_FAILURE';


export const GET_MULTIPLE_LMT_HEADER_REQUEST = 'GET_MULTIPLE_LMT_HEADER_REQUEST';
export const GET_MULTIPLE_LMT_HEADER_SUCCESS = 'GET_MULTIPLE_LMT_HEADER_SUCCESS';
export const GET_MULTIPLE_LMT_HEADER_FAILURE = 'GET_MULTIPLE_LMT_HEADER_FAILURE';

export const SPORTSBOOK_TABS_EVENTS_COUNT_WS_UPDATE = 'SPORTSBOOK_TABS_EVENTS_COUNT_WS_UPDATE';

export const PAGE_VIEW = 'PAGE_VIEW';
export const TOGGLE_SIDE_MENU = 'TOGGLE_SIDE_MENU';
export const SHOW_OCCUPATION_POPUP = 'SHOW_OCCUPATION_POPUP';

export const SHARE_COUPON_SUCCESS = 'SHARE_COUPON_SUCCESS';

export const CAPTCHA_REQUIRED = 'CAPTCHA_REQUIRED';

export const POST_WITHDRAW_REQUEST = 'POST_WITHDRAW_REQUEST';
export const POST_WITHDRAW_SUCCESS = 'POST_WITHDRAW_SUCCESS';
export const POST_WITHDRAW_FAILURE = 'POST_WITHDRAW_FAILURE';

export const FORGOT_PASSWORD_OPTIONS_REQUEST = 'FORGOT_PASSWORD_OPTIONS_REQUEST';
export const FORGOT_PASSWORD_OPTIONS_SUCCESS = 'FORGOT_PASSWORD_OPTIONS_SUCCESS';
export const FORGOT_PASSWORD_OPTIONS_FAILURE = 'FORGOT_PASSWORD_OPTIONS_FAILURE';

export const FORGOT_PASSWORD_SEND_OTP_REQUEST = 'FORGOT_PASSWORD_SEND_OTP_REQUEST';
export const FORGOT_PASSWORD_SEND_OTP_SUCCESS = 'FORGOT_PASSWORD_SEND_OTP_SUCCESS';
export const FORGOT_PASSWORD_SEND_OTP_FAILURE = 'FORGOT_PASSWORD_SEND_OTP_FAILURE';

export const FORGOT_PASSWORD_SEND_EMAIL_REQUEST = 'FORGOT_PASSWORD_SEND_EMAIL_REQUEST';
export const FORGOT_PASSWORD_SEND_EMAIL_SUCCESS = 'FORGOT_PASSWORD_SEND_EMAIL_SUCCESS';
export const FORGOT_PASSWORD_SEND_EMAIL_FAILURE = 'FORGOT_PASSWORD_SEND_EMAIL_FAILURE';

export const FORGOT_PASSWORD_CHANGE_WITH_EMAIL_REQUEST = 'FORGOT_PASSWORD_CHANGE_WITH_EMAIL_REQUEST';
export const FORGOT_PASSWORD_CHANGE_WITH_EMAIL_SUCCESS = 'FORGOT_PASSWORD_CHANGE_WITH_EMAIL_SUCCESS';
export const FORGOT_PASSWORD_CHANGE_WITH_EMAIL_FAILURE = 'FORGOT_PASSWORD_CHANGE_WITH_EMAIL_FAILURE';

export const FORGOT_PASSWORD_CHANGE_WITH_PHONE_NUMBER_REQUEST = 'FORGOT_PASSWORD_CHANGE_WITH_PHONE_NUMBER_REQUEST';
export const FORGOT_PASSWORD_CHANGE_WITH_PHONE_NUMBER_SUCCESS = 'FORGOT_PASSWORD_CHANGE_WITH_PHONE_NUMBER_SUCCESS';
export const FORGOT_PASSWORD_CHANGE_WITH_PHONE_NUMBER_FAILURE = 'FORGOT_PASSWORD_CHANGE_WITH_PHONE_NUMBER_FAILURE';

export const FORGOT_PASSWORD_CHECK_EMAIL_CODE_REQUEST = 'FORGOT_PASSWORD_CHECK_EMAIL_CODE_REQUEST';
export const FORGOT_PASSWORD_CHECK_EMAIL_CODE_SUCCESS = 'FORGOT_PASSWORD_CHECK_EMAIL_CODE_SUCCESS';
export const FORGOT_PASSWORD_CHECK_EMAIL_CODE_FAILURE = 'FORGOT_PASSWORD_CHECK_EMAIL_CODE_FAILURE';

export const SAVE_FORGOT_PASSWORD_UNKNOWN_USER_DATA = 'SAVE_FORGOT_PASSWORD_UNKNOWN_USER_DATA';
export const RESET_FORGOT_PASSWORD_UNKNOWN_USER_DATA = 'RESET_FORGOT_PASSWORD_UNKNOWN_USER_DATA';

export const GET_TRIBUN_USER_AGREEMENT_REQUEST = 'GET_TRIBUN_USER_AGREEMENT_REQUEST';
export const GET_TRIBUN_USER_AGREEMENT_SUCCESS = 'GET_TRIBUN_USER_AGREEMENT_SUCCESS';
export const GET_TRIBUN_USER_AGREEMENT_FAILURE = 'GET_TRIBUN_USER_AGREEMENT_FAILURE';

export const GET_TRIBUN_TERM_OF_USE_REQUEST = 'GET_TRIBUN_TERM_OF_USE_REQUEST';
export const GET_TRIBUN_TERM_OF_USE_SUCCESS = 'GET_TRIBUN_TERM_OF_USE_SUCCESS';
export const GET_TRIBUN_TERM_OF_USE_FAILURE = 'GET_TRIBUN_TERM_OF_USE_FAILURE';

export const FETCH_MARKET_INFO_REQUEST = 'FETCH_MARKET_INFO_REQUEST';
export const FETCH_MARKET_INFO_SUCCESS = 'FETCH_MARKET_INFO_SUCCESS';
export const FETCH_MARKET_INFO_FAILURE = 'FETCH_MARKET_INFO_FAILURE';

export const GET_BALANCE_HISTORY_REQUEST = 'GET_BALANCE_HISTORY_REQUEST';
export const GET_BALANCE_HISTORY_SUCCESS = 'GET_BALANCE_HISTORY_SUCCESS';
export const GET_BALANCE_HISTORY_FAILURE = 'GET_BALANCE_HISTORY_FAILURE';

export const GET_WITHDRAW_INFO_REQUEST = 'GET_WITHDRAW_INFO_REQUEST';
export const GET_WITHDRAW_INFO_SUCCESS = 'GET_WITHDRAW_INFO_SUCCESS';
export const GET_WITHDRAW_INFO_FAILURE = 'GET_WITHDRAW_INFO_FAILURE';

export const GET_IDDAA_COUPON_INFO_REQUEST = 'GET_IDDAA_COUPON_INFO_REQUEST';
export const GET_IDDAA_COUPON_INFO_SUCCESS = 'GET_IDDAA_COUPON_INFO_SUCCESS';
export const GET_IDDAA_COUPON_INFO_FAILURE = 'GET_IDDAA_COUPON_INFO_FAILURE';

export const GET_SPOR_TOTO_COUPON_INFO_REQUEST = 'GET_SPOR_TOTO_COUPON_INFO_REQUEST';
export const GET_SPOR_TOTO_COUPON_INFO_SUCCESS = 'GET_SPOR_TOTO_COUPON_INFO_SUCCESS';
export const GET_SPOR_TOTO_COUPON_INFO_FAILURE = 'GET_SPOR_TOTO_COUPON_INFO_FAILURE';

export const GET_COMMERCIAL_MESSAGE_AGREEMENT_REQUEST = 'GET_COMMERCIAL_MESSAGE_AGREEMENT_REQUEST';
export const GET_COMMERCIAL_MESSAGE_AGREEMENT_SUCCESS = 'GET_COMMERCIAL_MESSAGE_AGREEMENT_SUCCESS';
export const GET_COMMERCIAL_MESSAGE_AGREEMENT_FAILURE = 'GET_COMMERCIAL_MESSAGE_AGREEMENT_FAILURE';

export const GET_RAFFLE_COMMERCIAL_MESSAGE_AGREEMENT_REQUEST = 'GET_RAFFLE_COMMERCIAL_MESSAGE_AGREEMENT_REQUEST';
export const GET_RAFFLE_COMMERCIAL_MESSAGE_AGREEMENT_SUCCESS = 'GET_RAFFLE_COMMERCIAL_MESSAGE_AGREEMENT_SUCCESS';
export const GET_RAFFLE_COMMERCIAL_MESSAGE_AGREEMENT_FAILURE = 'GET_RAFFLE_COMMERCIAL_MESSAGE_AGREEMENT_FAILURE';

export const GET_CHANCE_GAMES_AGREEMENT_REQUEST = 'GET_CHANCE_GAMES_AGREEMENT_REQUEST';
export const GET_CHANCE_GAMES_AGREEMENT_SUCCESS = 'GET_CHANCE_GAMES_AGREEMENT_SUCCESS';
export const GET_CHANCE_GAMES_AGREEMENT_FAILURE = 'GET_CHANCE_GAMES_AGREEMENT_FAILURE';

export const GET_CHANCE_GAMES_USER_AGREEMENT_REQUEST = 'GET_CHANCE_GAMES_USER_AGREEMENT_REQUEST';
export const GET_CHANCE_GAMES_USER_AGREEMENT_SUCCESS = 'GET_CHANCE_GAMES_USER_AGREEMENT_SUCCESS';
export const GET_CHANCE_GAMES_USER_AGREEMENT_FAILURE = 'GET_CHANCE_GAMES_USER_AGREEMENT_FAILURE';

export const GET_DIGITAL_GAMES_REQUEST = 'GET_DIGITAL_GAMES_REQUEST';
export const GET_DIGITAL_GAMES_SUCCESS = 'GET_DIGITAL_GAMES_SUCCESS';
export const GET_DIGITAL_GAMES_FAILURE = 'GET_DIGITAL_GAMES_FAILURE';


export const DIGITAL_GAMES_POLICY_ACCEPTED = 'DIGITAL_GAMES_POLICY_ACCEPTED';

export const DIGITAL_GAMES_VALIDATE_TOKEN = 'DIGITAL_GAMES_VALIDATE_TOKEN';
export const DIGITAL_GAMES_CREATE_SESSION = 'DIGITAL_GAMES_CREATE_SESSION';

export const PERSONALIZATION_POLICY_UPDATED = 'PERSONALIZATION_POLICY_UPDATED';
export const DIGITAL_GAMES_NEXT_GAME_REQUEST = 'DIGITAL_GAMES_NEXT_GAME_REQUEST';
export const DIGITAL_GAMES_NEXT_GAME_SUCCESS = 'DIGITAL_GAMES_NEXT_GAME_SUCCESS';
export const DIGITAL_GAMES_NEXT_GAME_FAILURE = 'DIGITAL_GAMES_NEXT_GAME_FAILURE';
export const UPDATE_IS_EYE_OPEN = 'UPDATE_IS_EYE_OPEN';

//Put personal email permissions

export const UPDATE_CANCEL_EMAIL_PERMISSION_REQUEST = 'UPDATE_CANCEL_EMAIL_PERMISSION_REQUEST';
export const UPDATE_CANCEL_EMAIL_PERMISSION_SUCCESS = 'UPDATE_CANCEL_EMAIL_PERMISSION_SUCCESS';
export const UPDATE_CANCEL_EMAIL_PERMISSION_FAILURE = 'UPDATE_CANCEL_EMAIL_PERMISSION_FAILURE';

// Horse Racing
export const GET_HIPPODROMES = 'GET_HIPPODROMES';
export const GET_HIPPODROMES_SUCCESS = 'GET_HIPPODROMES_SUCCESS';
export const GET_HIPPODROMES_FAILURE = 'GET_HIPPODROMES_FAILURE';

export const GET_ALL_HIPPODROMES = 'GET_ALL_HIPPODROMES';
export const GET_ALL_HIPPODROMES_SUCCESS = 'GET_ALL_HIPPODROMES_SUCCESS';
export const GET_ALL_HIPPODROMES_FAILURE = 'GET_ALL_HIPPODROMES_FAILURE';

export const GET_HOMEPAGE_HIPPODROMES = 'GET_HOMEPAGE_HIPPODROMES';
export const GET_HOMEPAGE_HIPPODROMES_SUCCESS = 'GET_HOMEPAGE_HIPPODROMES_SUCCESS';
export const GET_HOMEPAGE_HIPPODROMES_FAILURE = 'GET_HOMEPAGE_HIPPODROMES_FAILURE';

export const GET_HIPPODROMES_BETS = 'GET_HIPPODROMES_BETS';
export const GET_HIPPODROMES_BETS_SUCCESS = 'GET_HIPPODROMES_BETS_SUCCESS';
export const GET_HIPPODROMES_BETS_FAILURE = 'GET_HIPPODROMES_BETS_FAILURE';

export const GET_HIPPODROMES_BET_DETAILS = 'GET_HIPPODROMES_BETS_DETAILS';
export const GET_HIPPODROMES_BET_DETAILS_SUCCESS = 'GET_HIPPODROMES_BETS_DETAILS_SUCCESS';
export const GET_HIPPODROMES_BET_DETAILS_FAILURE = 'GET_HIPPODROMES_BETS_DETAILS_FAILURE';
export const SET_SELECTED_PROGRAM_LEG = 'SET_SELECTED_PROGRAM_LEG';
export const SET_FIXED_ODD_BADGE = 'SET_FIXED_ODD_BADGE';
export const SET_FIXED_ODD_INFO = 'SET_FIXED_ODD_INFO';
export const SET_PROGRAM_TYPE = 'SET_PROGRAM_TYPE';
export const TOGGLE_TJK_TV = 'TOGGLE_TJK_TV';

export const SET_SELECTED_HIPPODROME = 'SET_SELECTED_HIPPODROME';
export const SET_SELECTED_HIPPODROME_RACE_DATE = 'SET_SELECTED_HIPPODROME_RACE_DATE';
export const SET_SELECTED_BET_TYPE = 'SET_SELECTED_BET_TYPE';
export const SET_SELECTED_RACE_NUMBER = 'SET_SELECTED_RACE_NUMBER';

export const SELECT_HORSE = 'SELECT_HORSE';
export const REMOVE_HORSE = 'REMOVE_HORSE';
export const SELECT_ALL_HORSES = 'SELECT_ALL_HORSES';
export const REMOVE_ALL_HORSES = 'REMOVE_ALL_HORSES';
export const RESET_HR_BETSLIP = 'RESET_HR_BETSLIP';
export const TOGGLE_HR_BETSLIP = 'TOGGLE_HR_BETSLIP';
export const TOGGLE_SYSTEM_MODAL = 'TOGGLE_SYSTEM_MODAL';
export const CHANGE_BULTEN_RACENUMBER = 'CHANGE_BULTEN_RACENUMBER';
export const SET_HR_BETSLIP_FROM_LOCAL_STORAGE = 'SET_HR_BETSLIP_FROM_LOCAL_STORAGE';
export const SET_HR_BETSLIP_MULTIPLIER = 'SET_HR_BETSLIP_MULTIPLIER';
export const SET_HR_FIXED_ODD_MULTIPLIER = 'SET_HR_FIXED_ODD_MULTIPLIER';
export const SET_HR_BETSLIP_COUPON_COUNT = 'SET_HR_BETSLIP_COUPON_COUNT';
export const SET_HR_BETSLIP_ALL_VARIATION = 'SET_HR_BETSLIP_ALL_VARIATION';
export const SET_HR_BETSLIP_FROM_COUPON = 'SET_HR_BETSLIP_FROM_COUPON';

export const SET_FROM_AUTHOR_DATA = 'SET_FROM_AUTHOR_DATA';
export const CLEAR_FROM_AUTHOR_DATA = 'CLEAR_FROM_AUTHOR_DATA';

export const PLAY_TJK_COUPON_REQUEST = 'PLAY_TJK_COUPON_REQUEST';
export const PLAY_TJK_COUPON_SUCCESS = 'PLAY_TJK_COUPON_SUCCESS';
export const PLAY_TJK_COUPON_FAILURE = 'PLAY_TJK_COUPON_FAILURE';

export const VERIFY_TJK_COUPON_REQUEST = 'VERIFY_TJK_COUPON_REQUEST';
export const VERIFY_TJK_COUPON_SUCCESS = 'VERIFY_TJK_COUPON_SUCCESS';
export const VERIFY_TJK_COUPON_FAILURE = 'VERIFY_TJK_COUPON_FAILURE';

export const CANCEL_TJK_COUPON_REQUEST = 'CANCEL_TJK_COUPON_REQUEST';
export const CANCEL_TJK_COUPON_SUCCESS = 'CANCEL_TJK_COUPON_SUCCESS';
export const CANCEL_TJK_COUPON_FAILURE = 'CANCEL_TJK_COUPON_FAILURE';

export const GET_HORSE_RACE_AUTHORS = 'GET_HORSE_RACE_AUTHORS';
export const GET_HORSE_RACE_AUTHORS_SUCCESS = 'GET_HORSE_RACE_AUTHORS_SUCCESS';
export const GET_HORSE_RACE_AUTHORS_FAILURE = 'GET_HORSE_RACE_AUTHORS_FAILURE';

export const GET_HORSE_RACE_AUTHOR_DETAILS = 'GET_HORSE_RACE_AUTHOR_DETAILS';
export const GET_HORSE_RACE_AUTHOR_DETAILS_SUCCESS = 'GET_HORSE_RACE_AUTHOR_DETAILS_SUCCESS';
export const GET_HORSE_RACE_AUTHOR_DETAILS_FAILURE = 'GET_HORSE_RACE_AUTHOR_DETAILS_FAILURE';

export const GET_HORSE_RACE_AUTHOR_COMMENTS = 'GET_HORSE_RACE_AUTHOR_COMMENTS';
export const GET_HORSE_RACE_AUTHOR_COMMENTS_SUCCESS = 'GET_HORSE_RACE_AUTHOR_COMMENTS_SUCCESS';
export const GET_HORSE_RACE_AUTHOR_COMMENTS_FAILURE = 'GET_HORSE_RACE_AUTHOR_COMMENTS_FAILURE';

export const GET_HORSE_RACE_AGF_GAME_SELECT = 'GET_HORSE_RACE_AGF_GAME_SELECT';
export const GET_HORSE_RACE_AGF_GAME_SELECT_SUCCESS = 'GET_HORSE_RACE_AGF_GAME_SELECT_SUCCESS';
export const GET_HORSE_RACE_AGF_GAME_SELECT_FAILURE = 'GET_HORSE_RACE_AGF_GAME_SELECT_FAILURE';

export const GET_HORSE_RACE_AGF_HIPPODROMES = 'GET_HORSE_RACE_AGF_HIPPODROMES';
export const GET_HORSE_RACE_AGF_HIPPODROMES_SUCCESS = 'GET_HORSE_RACE_AGF_HIPPODROMES_SUCCESS';
export const GET_HORSE_RACE_AGF_HIPPODROMES_FAILURE = 'GET_HORSE_RACE_AGF_HIPPODROMES_FAILURE';
export const SET_SELECTED_AGF_HIPPODROME = 'SET_SELECTED_AGF_HIPPODROME';
export const SET_SELECTED_AGF_SIX_PICK_ORDER = 'SET_SELECTED_AGF_SIX_PICK_ORDER';
export const SET_SELECTED_AGF_LEG = 'SET_SELECTED_AGF_LEG';

export const GET_HORSE_RACE_SELECTED_HORSES = 'GET_HORSE_RACE_SELECTED_HORSES';
export const GET_HORSE_RACE_SELECTED_HORSES_SUCCESS = 'GET_HORSE_RACE_SELECTED_HORSES_SUCCESS';
export const GET_HORSE_RACE_SELECTED_HORSES_FAILURE = 'GET_HORSE_RACE_SELECTED_HORSES_FAILURE';

export const GET_HORSE_RACE_AGF_LIST = 'GET_HORSE_RACE_AGF_LIST';
export const GET_HORSE_RACE_AGF_LIST_SUCCESS = 'GET_HORSE_RACE_AGF_LIST_SUCCESS';
export const GET_HORSE_RACE_AGF_LIST_FAILURE = 'GET_HORSE_RACE_AGF_LIST_FAILURE';

export const HORSE_RACING_WS_AGF_UPDATE = 'HORSE_RACING_WS_AGF_UPDATE';
export const HORSE_RACING_WS_PROGRAM_UPDATE = 'HORSE_RACING_WS_PROGRAM_UPDATE';
export const HORSE_RACING_WS_BETSLIP_UPDATE = 'HORSE_RACING_WS_BETSLIP_UPDATE';
export const HORSE_RACING_WS_PROBABLES_UPDATE = 'HORSE_RACING_WS_PROBABLES_UPDATE';
export const FIXED_ODD_CHANGE = 'FIXED_ODD_CHANGE';

export const GET_HORSE_RACING_CONTINUED_COUPONS_REQUEST = 'GET_HORSE_RACING_CONTINUED_COUPONS_REQUEST';
export const GET_HORSE_RACING_CONTINUED_COUPONS_SUCCESS = 'GET_HORSE_RACING_CONTINUED_COUPONS_SUCCESS';
export const GET_HORSE_RACING_CONTINUED_COUPONS_FAILURE = 'GET_HORSE_RACING_CONTINUED_COUPONS_FAILURE';

export const GET_HORSE_RACING_WON_COUPONS_REQUEST = 'GET_HORSE_RACING_WON_COUPONS_REQUEST';
export const GET_HORSE_RACING_WON_COUPONS_SUCCESS = 'GET_HORSE_RACING_WON_COUPONS_SUCCESS';
export const GET_HORSE_RACING_WON_COUPONS_FAILURE = 'GET_HORSE_RACING_WON_COUPONS_FAILURE';

export const GET_HORSE_RACING_LOST_COUPONS_REQUEST = 'GET_HORSE_RACING_LOST_COUPONS_REQUEST';
export const GET_HORSE_RACING_LOST_COUPONS_SUCCESS = 'GET_HORSE_RACING_LOST_COUPONS_SUCCESS';
export const GET_HORSE_RACING_LOST_COUPONS_FAILURE = 'GET_HORSE_RACING_LOST_COUPONS_FAILURE';

export const GET_HORSE_RACING_SAVED_COUPONS_REQUEST = 'GET_HORSE_RACING_SAVED_COUPONS_REQUEST';
export const GET_HORSE_RACING_SAVED_COUPONS_SUCCESS = 'GET_HORSE_RACING_SAVED_COUPONS_SUCCESS';
export const GET_HORSE_RACING_SAVED_COUPONS_FAILURE = 'GET_HORSE_RACING_SAVED_COUPONS_FAILURE';

export const GET_HORSE_RACING_COUPON_SAVE_REQUEST = 'GET_HORSE_RACING_COUPON_SAVE_REQUEST';
export const GET_HORSE_RACING_COUPON_SAVE_SUCCESS = 'GET_HORSE_RACING_COUPON_SAVE_SUCCESS';
export const GET_HORSE_RACING_COUPON_SAVE_FAILURE = 'GET_HORSE_RACING_COUPON_SAVE_FAILURE';

export const GET_HORSE_RACING_COUPON_RENAME_REQUEST = 'GET_HORSE_RACING_COUPON_RENAME_REQUEST';
export const GET_HORSE_RACING_COUPON_RENAME_SUCCESS = 'GET_HORSE_RACING_COUPON_RENAME_SUCCESS';
export const GET_HORSE_RACING_COUPON_RENAME_FAILURE = 'GET_HORSE_RACING_COUPON_RENAME_FAILURE';

export const GET_HORSE_RACING_COUPON_DELETE_REQUEST = 'GET_HORSE_RACING_COUPON_DELETE_REQUEST';
export const GET_HORSE_RACING_COUPON_DELETE_SUCCESS = 'GET_HORSE_RACING_COUPON_DELETE_SUCCESS';
export const GET_HORSE_RACING_COUPON_DELETE_FAILURE = 'GET_HORSE_RACING_COUPON_DELETE_FAILURE';

export const GET_HORSE_RACING_COMBINATIONS_REQUEST = 'GET_HORSE_RACING_COMBINATIONS_REQUEST';
export const GET_HORSE_RACING_COMBINATIONS_SUCCESS = 'GET_HORSE_RACING_COMBINATIONS_SUCCESS';
export const GET_HORSE_RACING_COMBINATIONS_FAILURE = 'GET_HORSE_RACING_COMBINATIONS_FAILURE';

export const GET_HORSE_RACING_SYSTEM_DETAIL_REQUEST = 'GET_HORSE_RACING_SYSTEM_DETAIL_REQUEST';
export const GET_HORSE_RACING_SYSTEM_DETAIL_SUCCESS = 'GET_HORSE_RACING_SYSTEM_DETAIL_SUCCESS';
export const GET_HORSE_RACING_SYSTEM_DETAIL_FAILURE = 'GET_HORSE_RACING_SYSTEM_DETAIL_FAILURE';

export const SET_HORSE_RACING_COUPONS_ACTIVE_FILTERS = 'SET_HORSE_RACING_COUPONS_ACTIVE_FILTERS';
export const RESET_HORSE_RACING_COUPONS_PAGINATION = 'RESET_HORSE_RACING_COUPONS_PAGINATION';

export const SET_HORSE_RACING_SCROLL_POSITION = 'SET_HORSE_RACING_SCROLL_POSITION';
export const SET_COUPONS_FILTERS = 'SET_COUPONS_FILTERS';
export const CLEAR_COUPON_STATE = 'CLEAR_COUPON_STATE';

export const GET_HORSE_RACE_COUPON_DETAIL_REQUEST = 'GET_HORSE_RACE_COUPON_DETAIL_REQUEST';
export const GET_HORSE_RACE_COUPON_DETAIL_SUCCESS = 'GET_HORSE_RACE_COUPON_DETAIL_SUCCESS';
export const GET_HORSE_RACE_COUPON_DETAIL_FAILURE = 'GET_HORSE_RACE_COUPON_DETAIL_FAILURE';

export const GET_HORSE_RACE_COUPON_PRIZE_REQUEST = 'GET_HORSE_RACE_COUPON_PRIZE_REQUEST';
export const GET_HORSE_RACE_COUPON_PRIZE_SUCCESS = 'GET_HORSE_RACE_COUPON_PRIZE_SUCCESS';
export const GET_HORSE_RACE_COUPON_PRIZE_FAILURE = 'GET_HORSE_RACE_COUPON_PRIZE_FAILURE';

export const GET_HORSE_RACE_PROBABILITIES_HIPPODROMES = 'GET_HORSE_RACE_PROBABILITIES_HIPPODROMES';
export const GET_HORSE_RACE_PROBABILITIES_HIPPODROMES_SUCCESS = 'GET_HORSE_RACE_PROBABILITIES_HIPPODROMES_SUCCESS';
export const GET_HORSE_RACE_PROBABILITIES_HIPPODROMES_FAILURE = 'GET_HORSE_RACE_PROBABILITIES_HIPPODROMES_FAILURE';
export const SET_SELECTED_PROBABILITIES_HIPPODROME = 'SET_SELECTED_PROBABILITIES_HIPPODROME';

export const GET_HORSE_RACE_PROBABILITIES = 'GET_HORSE_RACE_PROBABILITIES';
export const GET_HORSE_RACE_PROBABILITIES_SUCCESS = 'GET_HORSE_RACE_PROBABILITIES_SUCCESS';
export const GET_HORSE_RACE_PROBABILITIES_FAILURE = 'GET_HORSE_RACE_PROBABILITIES_FAILURE';
export const SET_SELECTED_HORSE_RACE_PROBABILITIES = 'SET_SELECTED_HORSE_RACE_PROBABILITIES';

export const GET_HORSE_RACEING_RESULT = 'GET_HORSE_RACEING_RESULT';
export const GET_HORSE_RACEING_RESULT_SUCCESS = 'GET_HORSE_RACEING_RESULT_SUCCESS';
export const GET_HORSE_RACEING_RESULT_FAILURE = 'GET_HORSE_RACEING_RESULT_FAILURE';

export const GET_HIPPODROME_HORSE_RACEING_RESULT = 'GET_HIPPODROME_HORSE_RACEING_RESULT';
export const GET_HIPPODROME_HORSE_RACEING_RESULT_SUCCESS = 'GET_HIPPODROME_HORSE_RACEING_RESULT_SUCCESS';
export const GET_HIPPODROME_HORSE_RACEING_RESULT_FAILURE = 'GET_HIPPODROME_HORSE_RACEING_RESULT_FAILURE';

export const GET_HIPPODROME_HORSE_RACEING_RUN_RESULT = 'GET_HIPPODROME_HORSE_RACEING_RUN_RESULT';
export const GET_HIPPODROME_HORSE_RACEING_RUN_RESULT_SUCCESS = 'GET_HIPPODROME_HORSE_RACEING_RUN_RESULT_SUCCESS';
export const GET_HIPPODROME_HORSE_RACEING_RUN_RESULT_FAILURE = 'GET_HIPPODROME_HORSE_RACEING_RUN_RESULT_FAILURE';

export const GET_HORSE_RACING_UPCOMING_RACES = 'GET_HORSE_RACING_UPCOMING_RACES';
export const GET_HORSE_RACING_UPCOMING_RACES_SUCCESS = 'GET_HORSE_RACING_UPCOMING_RACES_SUCCESS';
export const GET_HORSE_RACING_UPCOMING_RACES_FAILURE = 'GET_HORSE_RACING_UPCOMING_RACES_FAILURE';

export const GET_TJK_COUPON_INFO_REQUEST = 'GET_TJK_COUPON_INFO_REQUEST';
export const GET_TJK_COUPON_INFO_SUCCESS = 'GET_TJK_COUPON_INFO_SUCCESS';
export const GET_TJK_COUPON_INFO_FAILURE = 'GET_TJK_COUPON_INFO_FAILURE';

export const ADD_COMBINED_HORSE = 'ADD_COMBINED_HORSE';
export const REMOVE_COMBINED_HORSE = 'REMOVE_COMBINED_HORSE';
export const REPLACE_COMBINED_HORSE = 'REPLACE_COMBINED_HORSE';
export const SET_BETSLIP_TOAST = 'SET_BETSLIP_TOAST';
export const ADD_PROPOSITION = 'ADD_PROPOSITION';
export const REMOVE_PROPOSITION = 'REMOVE_PROPOSITION';
export const REPLACE_PROPOSITION = 'REPLACE_PROPOSITION';
export const SET_ORDERED_LEGS = 'SET_ORDERED_LEGS';
export const CHANGE_ODD = 'CHANGE_ODD';
export const SET_SYSTEM = 'SET_SYSTEM';
// Check if User Pre-Deactivated Status

export const PREDEACTIVATED_STATUS_FORGOT_PASSWORD_REQUEST = 'PREDEACTIVATED_STATUS_FORGOT_PASSWORD_REQUEST';
export const PREDEACTIVATED_STATUS_FORGOT_PASSWORD_SUCCESS = 'PREDEACTIVATED_STATUS_FORGOT_PASSWORD_SUCCESS';
export const PREDEACTIVATED_STATUS_FORGOT_PASSWORD_FAILURE = 'PREDEACTIVATED_STATUS_FORGOT_PASSWORD_FAILURE';


export const SET_SUBSCRIBED_TOPICS = 'SET_SUBSCRIBED_TOPICS';

// RaffleV2
export const GET_RAFFLE_TICKETS_REQUEST = 'GET_RAFFLE_TICKETS_REQUEST';
export const GET_RAFFLE_PLAYED_TICKETS_SUCCESS = 'GET_RAFFLE_PLAYED_TICKETS_SUCCESS';
export const GET_RAFFLE_CONCLUDED_TICKETS_SUCCESS = 'GET_RAFFLE_CONCLUDED_TICKETS_SUCCESS';
export const GET_RAFFLE_TICKETS_FAILURE = 'GET_RAFFLE_TICKETS_FAILURE';
export const RESET_RAFFLE_TICKETS_PAGINATION = 'RESET_RAFFLE_TICKETS_PAGINATION';

export const GET_RAFFLE_TICKET_DETAIL_REQUEST = 'GET_RAFFLE_TICKET_DETAIL_REQUEST';
export const GET_RAFFLE_TICKET_DETAIL_SUCCESS = 'GET_RAFFLE_TICKET_DETAIL_SUCCESS';
export const GET_RAFFLE_TICKET_DETAIL_FAILURE = 'GET_RAFFLE_TICKET_DETAIL_FAILURE';

export const GET_RAFFLE_RESULTS_REQUEST = 'GET_RAFFLE_RESULTS_REQUEST';
export const GET_RAFFLE_RESULTS_SUCCESS = 'GET_RAFFLE_RESULTS_SUCCESS';
export const GET_RAFFLE_RESULTS_FAILURE = 'GET_RAFFLE_RESULTS_FAILURE';
export const SET_RAFFLE_LIST_POSITION = 'SET_RAFFLE_LIST_POSITION';

// Static Screen
export const GET_STATIC_SCREEN_REQUEST = 'GET_STATIC_SCREEN_REQUEST';
export const GET_STATIC_SCREEN_SUCCESS = 'GET_STATIC_SCREEN_SUCCESS';
export const GET_STATIC_SCREEN_FAILURE = 'GET_STATIC_SCREEN_FAILURE';

export const GET_STATIC_CONTENT_SCREEN_REQUEST = 'GET_STATIC_CONTENT_SCREEN_REQUEST';
export const GET_STATIC_CONTENT_SCREEN_SUCCESS = 'GET_STATIC_CONTENT_SCREEN_SUCCESS';
export const GET_STATIC_CONTENT_SCREEN_FAILURE = 'GET_STATIC_CONTENT_SCREEN_FAILURE';

export const GET_STATIC_PAGE_REQUEST = 'GET_STATIC_PAGE_REQUEST';
export const GET_STATIC_PAGE_SUCCESS = 'GET_STATIC_PAGE_SUCCESS';
export const GET_STATIC_PAGE_FAILURE = 'GET_STATIC_PAGE_FAILURE';

// SPACE COUPON BANNER
export const GET_SECONDARY_HOME_BANNER_REQUEST = 'GET_SECONDARY_HOME_BANNER_REQUEST';
export const GET_SECONDARY_HOME_BANNER_SUCCESS = 'GET_SECONDARY_HOME_BANNER_SUCCESS';
export const GET_SECONDARY_HOME_BANNER_FAILURE = 'GET_SECONDARY_HOME_BANNER_FAILURE';

// Authors

export const GET_AUTHORS_LIST_REQUEST = 'GET_AUTHORS_LIST_REQUEST';
export const GET_AUTHORS_LIST_SUCCESS = 'GET_AUTHORS_LIST_SUCCESS';
export const GET_AUTHORS_LIST_FAILURE = 'GET_AUTHORS_LIST_FAILURE';

export const GET_AUTHORS_HEADERS_REQUEST = 'GET_AUTHORS_HEADERS_REQUEST';
export const GET_AUTHORS_HEADERS_SUCCESS = 'GET_AUTHORS_HEADERS_SUCCESS';
export const GET_AUTHORS_HEADERS_FAILURE = 'GET_AUTHORS_HEADERS_FAILURE';

export const GET_AUTHORS_FILTER_REQUEST = 'GET_AUTHORS__FILTER__REQUEST';
export const GET_AUTHORS_FILTER_SUCCESS = 'GET_AUTHORS__FILTER__SUCCESS';
export const GET_AUTHORS_FILTER__FAILURE = 'GET_AUTHORS__FILTER__FAILURE';

export const GET_AUTHOR_DETAIL_REQUEST = 'GET_AUTHOR_DETAIL_REQUEST';
export const GET_AUTHOR_DETAIL_SUCCESS = 'GET_AUTHOR_DETAIL_SUCCESS';
export const GET_AUTHOR_DETAIL_FAILURE = 'GET_AUTHOR_DETAIL_FAILURE';

export const GET_AUTHOR_LAST_COMMENTS_STATUS_REQUEST = 'GET_AUTHOR_LAST_COMMENTS_STATUS_REQUEST';
export const GET_AUTHOR_LAST_COMMENTS_STATUS_SUCCESS = 'GET_AUTHOR_LAST_COMMENTS_STATUS_SUCCESS';
export const GET_AUTHOR_LAST_COMMENTS_STATUS_FAILURE = 'GET_AUTHOR_LAST_COMMENTS_STATUS_FAILURE';

export const GET_AUTHOR_RESET = 'GET_AUTHOR_RESET';
export const GET_SCRATCH_TICKETS_REQUEST = 'GET_SCRATCH_TICKETS_REQUEST';
export const GET_SCRATCH_TICKETS_SUCCESS = 'GET_SCRATCH_TICKETS_SUCCESS';
export const GET_SCRATCH_TICKETS_FAILURE = 'GET_SCRATCH_TICKETS_FAILURE';

export const SCRATCH_BUY_TICKETS_REQUEST = 'SCRATCH_BUY_TICKETS_REQUEST';
export const SCRATCH_BUY_TICKETS_SUCCESS = 'SCRATCH_BUY_TICKETS_SUCCESS';
export const SCRATCH_BUY_TICKETS_FAILURE = 'SCRATCH_BUY_TICKETS_FAILURE';

export const GET_SCRATCH_MY_TICKETS_REQUEST = 'GET_SCRATCH_MY_TICKETS_REQUEST';
export const GET_SCRATCH_MY_TICKETS_SUCCESS = 'GET_SCRATCH_MY_TICKETS_SUCCESS';
export const GET_SCRATCH_MY_TICKETS_FAILURE = 'GET_SCRATCH_MY_TICKETS_FAILURE';

export const GET_SCRATCH_TICKETS_DATA_REQUEST = 'GET_SCRATCH_TICKETS_DATA_REQUEST';
export const GET_SCRATCH_TICKETS_DATA_SUCCESS = 'GET_SCRATCH_TICKETS_DATA_SUCCESS';
export const GET_SCRATCH_TICKETS_DATA_FAILURE = 'GET_SCRATCH_TICKETS_DATA_FAILURE';

export const SCRATCHED_TICKETS_REQUEST = 'SCRATCHED_TICKETS_REQUEST';
export const SCRATCHED_TICKETS_SUCCESS = 'SCRATCHED_TICKETS_SUCCESS';
export const SCRATCHED_TICKETS_FAILURE = 'SCRATCHED_TICKETS_FAILURE';


export const SCRATCHED_TICKETS_DRAW_REQUEST = 'SCRATCHED_TICKETS_DRAW_REQUEST';
export const SCRATCHED_TICKETS_DRAW_SUCCESS = 'SCRATCHED_TICKETS_DRAW_SUCCESS';
export const SCRATCHED_TICKETS_DRAW_FAILURE = 'SCRATCHED_TICKETS_DRAW_FAILURE';

export const RESET_SCRATCH_TICKETS_PAGINATION = 'RESET_SCRATCH_TICKETS_PAGINATION';

export const POPULAR_BETS_WS_ODD_REMOVE = 'POPULAR_BETS_WS_ODD_REMOVE';

export const GET_PERSONAL_MARKET_IDS_REQUEST = 'GET_PERSONAL_MARKET_IDS_REQUEST';
export const GET_PERSONAL_MARKET_IDS_SUCCESS = 'GET_PERSONAL_MARKET_IDS_SUCCESS';
export const GET_PERSONAL_MARKET_IDS_FAILURE = 'GET_PERSONAL_MARKET_IDS_FAILURE';

export const GET_POPULAR_MARKET_IDS_REQUEST = 'GET_POPULAR_MARKET_IDS_REQUEST';
export const GET_POPULAR_MARKET_IDS_SUCCESS = 'GET_POPULAR_MARKET_IDS_SUCCESS';
export const GET_POPULAR_MARKET_IDS_FAILURE = 'GET_POPULAR_MARKET_IDS_FAILURE';

export const GET_SPORTSBOOK_EVENTS_HASH_REQUEST = 'GET_SPORTSBOOK_EVENTS_HASH_REQUEST';
export const GET_SPORTSBOOK_EVENTS_HASH_SUCCESS = 'GET_SPORTSBOOK_EVENTS_HASH_SUCCESS';
export const GET_SPORTSBOOK_EVENTS_HASH_FAILURE = 'GET_SPORTSBOOK_EVENTS_HASH_FAILURE';

export const REST_SPORTSBOOK_EVENTS_HASH = 'REST_SPORTSBOOK_EVENTS_HASH';

export const GET_MATCH_CARD_IMPORTANT_MOMENTS_REQUEST = 'GET_MATCH_CARD_IMPORTANT_MOMENTS_REQUEST';
export const GET_MATCH_CARD_IMPORTANT_MOMENTS_SUCCESS = 'GET_MATCH_CARD_IMPORTANT_MOMENTS_SUCCESS';
export const GET_MATCH_CARD_IMPORTANT_MOMENTS_FAILURE = 'GET_MATCH_CARD_IMPORTANT_MOMENTS_FAILURE';

export const GET_IMPORTANT_MOMENTS_PLAYER_REQUEST = 'GET_IMPORTANT_MOMENTS_PLAYER_REQUEST';
export const GET_IMPORTANT_MOMENTS_PLAYER_SUCCESS = 'GET_IMPORTANT_MOMENTS_PLAYER_SUCCESS';
export const GET_IMPORTANT_MOMENTS_PLAYER_FAILURE = 'GET_IMPORTANT_MOMENTS_PLAYER_FAILURE';

export const AUTHENTICATE_IMPORTANT_MOMENT_STREAM_REQUEST = 'AUTHENTICATE_IMPORTANT_MOMENT_STREAM_REQUEST';
export const AUTHENTICATE_IMPORTANT_MOMENT_STREAM_SUCCESS = 'AUTHENTICATE_IMPORTANT_MOMENT_STREAM_SUCCESS';
export const AUTHENTICATE_IMPORTANT_MOMENT_STREAM_FAILURE = 'AUTHENTICATE_IMPORTANT_MOMENT_STREAM_FAILURE';

export const SET_SPORTSBOOK_HEADER_FILTERS = 'SET_SPORTSBOOK_HEADER_FILTERS';

export const GET_USER_NATIONAL_ID_REQUEST = 'GET_USER_NATIONAL_ID_REQUEST';
export const GET_USER_NATIONAL_ID_SUCCESS = 'GET_USER_NATIONAL_ID_SUCCESS';
export const GET_USER_NATIONAL_ID_FAILURE = 'GET_USER_NATIONAL_ID_FAILURE';


export const GET_PARENT_EVENTS_REQUEST = 'GET_PARENT_EVENTS_REQUEST';
export const GET_PARENT_EVENTS_SUCCESS = 'GET_PARENT_EVENTS_SUCCESS';
export const GET_PARENT_EVENTS_FAILURE = 'GET_PARENT_EVENTS_FAILURE';
export const TOGGLE_DUELLO_DETAIL = 'TOGGLE_DUELLO_DETAIL';
export const RESET_TOOGLE_DUELLO_DETAIL = 'RESET_TOOGLE_DUELLO_DETAIL';
export const SPORTSBOOK_EVENTS_DUELLOCHILD_WS_UPDATE = 'SPORTSBOOK_EVENTS_DUELLOCHILD_WS_UPDATE';
export const OPEN_DRAWER = 'OPEN_DRAWER';
export const CLOSE_DRAWER = 'CLOSE_DRAWER';

export const FORGOT_PASSWORD_OTP_VERIFY_REQUEST = 'FORGOT_PASSWORD_OTP_VERIFY_REQUEST';
export const FORGOT_PASSWORD_OTP_VERIFY_SUCCESS = 'FORGOT_PASSWORD_OTP_VERIFY_SUCCESS';
export const FORGOT_PASSWORD_OTP_VERIFY_FAILURE = 'FORGOT_PASSWORD_OTP_VERIFY_FAILURE';


export const SPOR_TOTO_SOCIAL_COUPON_REQUEST = 'SPOR_TOTO_SOCIAL_COUPON_REQUEST';
export const SPOR_TOTO_SOCIAL_COUPON_SUCCESS = 'SPOR_TOTO_SOCIAL_COUPON_SUCCESS';
export const SPOR_TOTO_SOCIAL_COUPON_FAILURE = 'SPOR_TOTO_SOCIAL_COUPON_FAILURE';

// User Campaign

export const BRING_YOUR_FRIEND_REQUEST = 'BRING_YOUR_FRIEND_REQUEST';
export const BRING_YOUR_FRIEND_SUCCESS = 'BRING_YOUR_FRIEND_SUCCESS';
export const BRING_YOUR_FRIEND_ERROR = 'BRING_YOUR_FRIEND_ERROR';

export const BRING_YOUR_FRIEND_STATUS_REQUEST = 'BRING_YOUR_FRIEND_STATUS_REQUEST';
export const BRING_YOUR_FRIEND_STATUS_SUCCESS = 'BRING_YOUR_FRIEND_STATUS_SUCCESS';
export const BRING_YOUR_FRIEND_STATUS_ERROR = 'BRING_YOUR_FRIEND_STATUS_ERROR';

export const REFERRED_FRIENDS_REQUEST = 'REFERRED_FRIENDS_REQUEST';
export const REFERRED_FRIENDS_SUCCESS = 'REFERRED_FRIENDS_SUCCESS';
export const REFERRED_FRIENDS_ERROR = 'REFERRED_FRIENDS_ERROR';

export const BRING_YOUR_FRIEND_AMOUNT_REQUEST = 'BRING_YOUR_FRIEND_AMOUNT_REQUEST';
export const BRING_YOUR_FRIEND_AMOUNT_SUCCESS = 'BRING_YOUR_FRIEND_AMOUNT_SUCCESS';
export const BRING_YOUR_FRIEND_AMOUNT_ERROR = 'BRING_YOUR_FRIEND_AMOUNT_ERROR';

export const DISPLAY_EMAIL_OTP_ACTION_SHEET_IGNORED = 'DISPLAY_EMAIL_OTP_ACTION_SHEET_IGNORED';
export const DISPLAY_SMS_OTP_ACTION_SHEET_IGNORED = 'DISPLAY_SMS_OTP_ACTION_SHEET_IGNORED';

export const GET_FILTERS_SORTING_REQUEST = 'GET_FILTERS_SORTING_REQUEST';
export const GET_FILTERS_SORTING_SUCCESS = 'GET_FILTERS_SORTING_SUCCESS';
export const GET_FILTERS_SORTING_FAILURE = 'GET_FILTERS_SORTING_FAILURE';

export const GET_SORTING_OPTIONS_REQUEST = 'GET_SORTING_OPTIONS_REQUEST';
export const GET_SORTING_OPTIONS_SUCCESS = 'GET_SORTING_OPTIONS_SUCCESS';
export const GET_SORTING_OPTIONS_FAILURE = 'GET_SORTING_OPTIONS_FAILURE';

export const TRUSTED_DEVICE_ERROR = 'TRUSTED_DEVICE_ERROR';
export const SET_OTP_INFO = 'SET_OTP_INFO';
export const SET_OTP_ERROR = 'SET_OTP_ERROR';
export const RESET_OTP_ERROR = 'RESET_OTP_ERROR';
export const SEND_OTP_ERROR = 'SEND_OTP_ERROR';

export const GET_PLAYER_ANALYSIS_REQUEST = 'GET_PLAYER_ANALYSIS_REQUEST';
export const GET_PLAYER_ANALYSIS_SUCCESS = 'GET_PLAYER_ANALYSIS_SUCCESS';
export const GET_PLAYER_ANALYSIS_FAILURE = 'GET_PLAYER_ANALYSIS_FAILURE';

export const CHECK_PLAYER_ANALYSIS_AVAILABILITY_REQUEST = 'CHECK_PLAYER_ANALYSIS_AVAILABILITY_REQUEST';
export const CHECK_PLAYER_ANALYSIS_AVAILABILITY_SUCCESS = 'CHECK_PLAYER_ANALYSIS_AVAILABILITY_SUCCESS';
export const CHECK_PLAYER_ANALYSIS_AVAILABILITY_FAILURE = 'CHECK_PLAYER_ANALYSIS_AVAILABILITY_FAILURE';

export const SET_EVENT_ROW_COLLAPSED = 'SET_EVENT_ROW_COLLAPSED';

export const GET_HOME_PAGE_GAME_LIST_REQUEST = 'GET_HOME_PAGE_GAME_LIST_REQUEST';
export const GET_HOME_PAGE_GAME_LIST_SUCCESS = 'GET_HOME_PAGE_GAME_LIST_SUCCESS';
export const GET_HOME_PAGE_GAME_LIST_FAILURE = 'GET_HOME_PAGE_GAME_LIST_FAILURE';

// Payment Request
export const GET_PAYMENT_REQUEST_TRANSACTIONS_REQUEST = 'GET_PAYMENT_REQUEST_TRANSACTIONS_REQUEST';
export const GET_PAYMENT_REQUEST_TRANSACTIONS_SUCCESS = 'GET_PAYMENT_REQUEST_TRANSACTIONS_SUCCESS';
export const GET_PAYMENT_REQUEST_TRANSACTIONS_FAILURE = 'GET_PAYMENT_REQUEST_TRANSACTIONS_FAILURE';
export const RESET_PAYMENT_REQUEST_PAGINATION = 'RESET_PAYMENT_REQUEST_PAGINATION';
export const CREATE_PAYMENT_REQUEST_REQUEST = 'CREATE_PAYMENT_REQUEST_REQUEST';
export const CREATE_PAYMENT_REQUEST_SUCCESS = 'CREATE_PAYMENT_REQUEST_SUCCESS';
export const CREATE_PAYMENT_REQUEST_FAILURE = 'CREATE_PAYMENT_REQUEST_FAILURE';
export const CREATE_DIRECT_PAYMENT_REQUEST_REQUEST = 'CREATE_DIRECT_PAYMENT_REQUEST_REQUEST';
export const CREATE_DIRECT_PAYMENT_REQUEST_SUCCESS = 'CREATE_DIRECT_PAYMENT_REQUEST_SUCCESS';
export const CREATE_DIRECT_PAYMENT_REQUEST_FAILURE = 'CREATE_DIRECT_PAYMENT_REQUEST_FAILURE';
export const MARK_PAYMENT_REQUEST_TRANSACTION_COMPLETED = 'MARK_PAYMENT_REQUEST_TRANSACTION_COMPLETED';

// Fast Deposit Analytics
export const FAST_DEPOSIT_VIEW_PAGE = 'FAST_DEPOSIT_VIEW_PAGE';
export const FAST_DEPOSIT_CLICK_SEND_REQUEST = 'FAST_DEPOSIT_CLICK_SEND_REQUEST';
export const FAST_DEPOSIT_CLICK_CANCEL_BUTTON = 'FAST_DEPOSIT_CLICK_CANCEL_BUTTON';
export const FAST_DEPOSIT_CLICK_CONFIRM_BUTTON = 'FAST_DEPOSIT_CLICK_CONFIRM_BUTTON';
export const FAST_DEPOSIT_CLICK_HOW_TO_BUTTON = 'FAST_DEPOSIT_CLICK_HOW_TO_BUTTON';
export const FAST_DEPOSIT_CLICK_HELP_BUTTON = 'FAST_DEPOSIT_CLICK_HELP_BUTTON';
export const FAST_DEPOSIT_CLICK_CANCEL_INFO = 'FAST_DEPOSIT_CLICK_CANCEL_INFO';
export const FAST_DEPOSIT_VIEW_CANCEL_REASON = 'FAST_DEPOSIT_VIEW_CANCEL_REASON';
export const FAST_DEPOSIT_CLICK_RETRY_BUTTON = 'FAST_DEPOSIT_CLICK_RETRY_BUTTON';

export const SET_SPORTS_BOOK_EVENTS_COUNT = 'SET_SPORTS_BOOK_EVENTS_COUNT';
export const SET_PREVIEW_FILTERS = 'SET_PREVIEW_FILTERS';
